(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header-glow2"] && !Shopify.designMode) return;
  try {
    
  /* Toggles .is-stuck once the page scrolls past the 42px announcement bar.
     A class rather than inline styles, so the transition stays in CSS. */
  (function () {
    function wire() {
      var header = document.querySelector('.mh');
      if (!header) return;
      function sync() {
        header.classList.toggle('is-stuck', window.scrollY > 42);
      }
      sync();
      window.addEventListener('scroll', sync, { passive: true });
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', wire);
    } else {
      wire();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rp-accordion-image"] && !Shopify.designMode) return;
  try {
    
  /* One item open at a time, the matching image shown. Closing the open item
     shows the first image again. Closed panels are inert so their text stays
     out of the tab order and the accessibility tree. */
  (() => {
    const init = (root) => {
      const items = [...root.querySelectorAll('[data-rp-accordion-item]')];
      const images = [...root.querySelectorAll('.rp-awi__image')];
      if (!items.length) return;
      const activate = (item) => {
        const wasOpen = item.classList.contains('rp-is-open');
        for (const el of items) {
          el.classList.remove('rp-is-open');
          el.querySelector('.rp-awi__trigger').setAttribute('aria-expanded', 'false');
          el.querySelector('.rp-awi__panel').inert = true;
        }
        for (const img of images) img.classList.remove('is-active');
        let index = 0;
        if (!wasOpen) {
          item.classList.add('rp-is-open');
          item.querySelector('.rp-awi__trigger').setAttribute('aria-expanded', 'true');
          item.querySelector('.rp-awi__panel').inert = false;
          index = items.indexOf(item);
        }
        if (images[index]) images[index].classList.add('is-active');
      };
      for (const item of items) item.querySelector('.rp-awi__trigger').addEventListener('click', () => activate(item));
      activate(items[0]);
    };
    const start = () => {
      for (const root of document.querySelectorAll('.section-rp-accordion-image')) {
        if (root.dataset.rpAwi) continue;
        root.dataset.rpAwi = '1';
        init(root);
      }
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
    else start();
    document.addEventListener('shopify:section:load', start);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rp-account-login"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const EMAIL = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    const testFor = (input) => (input.type === 'email' ? (v) => v.trim() !== '' && EMAIL.test(v.trim()) : (v) => v.trim() !== '');

    const validate = (input) => {
      const ok = testFor(input)(input.value);
      input.setAttribute('aria-invalid', String(!ok));
      const err = document.getElementById(input.getAttribute('aria-describedby'));
      if (err) err.hidden = ok;
      return ok;
    };

    const initForm = (form, statusText) => {
      const fields = [...form.querySelectorAll('input[required]')];
      for (const input of fields) {
        input.addEventListener('blur', () => validate(input));
        input.addEventListener('input', () => { if (input.getAttribute('aria-invalid') === 'true') validate(input); });
      }
      form.addEventListener('submit', (e) => {
        e.preventDefault();
        let ok = true;
        for (const input of fields) { if (!validate(input)) ok = false; }
        if (!ok) { fields.find((i) => i.getAttribute('aria-invalid') === 'true')?.focus(); return; }
        const status = form.parentElement.querySelector('[data-lg-status]');
        status.textContent = statusText;
        status.hidden = false;
        status.setAttribute('tabindex', '-1');
        status.focus();
      });
    };

    const initPanels = (root) => {
      const signin = root.querySelector('[data-lg-panel="signin"]');
      const reset = root.querySelector('[data-lg-panel="reset"]');
      const forgot = root.querySelector('[data-lg-forgot]');
      const back = root.querySelector('[data-lg-back]');
      forgot?.addEventListener('click', () => {
        signin.hidden = true;
        reset.hidden = false;
        const heading = reset.querySelector('h2');
        heading.setAttribute('tabindex', '-1');
        heading.focus();
      });
      back?.addEventListener('click', () => {
        reset.hidden = true;
        signin.hidden = false;
        const heading = signin.querySelector('h1');
        heading.setAttribute('tabindex', '-1');
        heading.focus();
      });
    };

    const start = () => {
      for (const root of document.querySelectorAll('.section-rp-account-login')) {
        if (root.dataset.rpLg) continue;
        root.dataset.rpLg = '1';
        initPanels(root);
        initForm(root.querySelector('[data-lg-form="signin"]'), 'Sign in runs on the live store.');
        initForm(root.querySelector('[data-lg-form="reset"]'), 'Password reset runs on the live store.');
      }
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
    else start();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rp-article"] && !Shopify.designMode) return;
  try {
    
  /* The folded contents close on Escape and hand focus back to their summary.
     The rail marks the section being read: aria-current flips on one link and
     the bar fades in by opacity. It only runs while the rail is on screen. */
  (function () {
    function wire() {
      var fold = document.querySelector('.rp-ar__toc--fold');
      if (fold) {
        fold.addEventListener('keydown', function (e) {
          if (e.key !== 'Escape' || !fold.open) return;
          fold.open = false;
          fold.querySelector('summary').focus();
        });
      }

      var rail = document.querySelector('.rp-ar__toc--rail');
      if (!rail) return;
      var links = Array.prototype.slice.call(rail.querySelectorAll('a[href^="#"]'));
      var pairs = links.map(function (a) {
        return { link: a, target: document.getElementById(decodeURIComponent(a.getAttribute('href').slice(1))) };
      }).filter(function (p) { return p.target; });
      if (!pairs.length) return;
      var wide = window.matchMedia('(min-width: 1200px)');
      var current = null;
      var queued = false;

      function update() {
        queued = false;
        if (!wide.matches) return;
        var line = window.innerHeight * 0.3;
        var active = null;
        for (var i = 0; i < pairs.length; i++) {
          if (pairs[i].target.getBoundingClientRect().top <= line) active = pairs[i].link;
        }
        if (active === current) return;
        if (current) current.removeAttribute('aria-current');
        if (active) active.setAttribute('aria-current', 'true');
        current = active;
      }

      function queue() {
        if (queued) return;
        queued = true;
        window.requestAnimationFrame(update);
      }

      window.addEventListener('scroll', queue, { passive: true });
      window.addEventListener('resize', queue);
      update();
    }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', wire);
    else wire();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rp-cart-drawer"] && !Shopify.designMode) return;
  try {
    
  /* Cart drawer behaviour: the panel (open, close, overlay, Escape, focus
     trap, focus return, scroll lock), the cart:changed listener, the tab
     pills, the line items (quantity, remove), the bottle rows and the
     subscription switch. Native APIs only. */
  (() => {
    const reduceMotion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const FOCUSABLE = 'a[href], button:not([disabled]), input:not([type="hidden"]):not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';
    const token = (name, fallback) => (getComputedStyle(document.documentElement).getPropertyValue(name) || '').trim() || fallback;
    const ms = (v) => (/ms$/.test(v) ? parseFloat(v) : parseFloat(v) * 1000);
    const DUR = (n) => ms(token('--rp-dur-' + n, ['', '160ms', '240ms', '360ms', '700ms'][n]));
    const EASE = (name) => token('--rp-ease-' + name, 'ease-out');
    const root = () => (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    const planOf = (line) => Number((line.selling_plan_allocation && line.selling_plan_allocation.selling_plan && line.selling_plan_allocation.selling_plan.id) || line.selling_plan || 0);

    /* the shop's money format, the way Shopify.formatMoney reads it */
    function formatMoney(cents, format, currency) {
      const n = Number(cents || 0) / 100;
      const [whole, dec] = n.toFixed(2).split('.');
      const grouped = whole.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      const out = (format || '$\x7b\x7bamount\x7d\x7d')
        .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, Math.round(n).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','))
        .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, whole.replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + dec)
        .replace(/\{\{\s*amount\s*\}\}/g, grouped + '.' + dec);
      return currency ? out + ' ' + currency : out;
    }

    /* ---- <rp-cart-drawer> ------------------------------------------------- */
    const DRAWER_TEMPLATE = '<style>.rp-sr-only{position:absolute;width:1px;height:1px;margin:-1px;padding:0;overflow:hidden;clip:rect(0,0,0,0);white-space:nowrap;border:0}svg{display:block}slot[name="header"]{display:contents}</style>'
      + '<div part="base"><div part="overlay"></div><div part="content">'
      + '<header part="header"><slot name="header"></slot><button type="button" part="close-button"><span class="rp-sr-only" data-close-label></span><svg aria-hidden="true" focusable="false" width="12" height="12" part="icon" fill="none" viewBox="0 0 10 10"><path stroke="currentColor" stroke-width="1.2" d="m1 1 8 8m0-8L1 9"/></svg></button></header>'
      + '<div part="body"><slot></slot></div>'
      + '<footer part="footer"><slot name="footer"></slot></footer>'
      + '</div></div>';

    class CartDrawer extends HTMLElement {
      constructor() {
        super();
        this.attachShadow({ mode: 'open' });
        this.shadowRoot.innerHTML = DRAWER_TEMPLATE;
        this.parts = { };
        for (const name of ['base', 'overlay', 'content', 'header', 'body', 'footer', 'close-button']) this.parts[name] = this.shadowRoot.querySelector('[part~="' + name + '"]');
        this.animations = [];
        this.closing = false;
        this.queue = [];
        this.chain = Promise.resolve();
        this.confirmedAt = 0;
        this.known = new Map();
      }

      connectedCallback() {
        if (this.wired) return;
        this.wired = true;
        this.shadowRoot.querySelector('[data-close-label]').textContent = this.dataset.closeLabel || 'Close';
        this.parts.overlay.addEventListener('click', () => this.hide());
        this.parts['close-button'].addEventListener('click', () => this.hide());
        this.footerSlot = this.shadowRoot.querySelector('slot[name="footer"]');
        this.footerSlot.addEventListener('slotchange', () => this.syncFooter());
        this.syncFooter();
        document.addEventListener('keydown', (e) => this.onKeydown(e));
        /* the last control pressed, for focus return where a click does not focus (Safari) */
        document.addEventListener('pointerdown', (e) => {
          const c = e.target.closest ? e.target.closest('button, a[href], input, select, [tabindex]') : null;
          if (c && !this.contains(c)) this.lastControl = c;
        }, true);
        document.addEventListener('click', (e) => {
          const t = e.target.closest ? e.target.closest('a.mh__icon--bag, [aria-controls="cart-drawer"], [data-open-cart]') : null;
          if (!t) return;
          e.preventDefault();
          this.show({ activator: t });
        });
        /* cart:changed and rp:open-cart (the menu's cart button, or an add that
           asks for the drawer directly) are collected for one tick and settled
           together, so an add that sends both events confirms once */
        document.addEventListener('cart:changed', (e) => this.collect('changed', e));
        document.addEventListener('rp:open-cart', (e) => this.collect('open', e));
        this.addEventListener('dialog:force-close', () => this.hide());
        this.addEventListener('line:quantity', (e) => this.onQuantity(e.detail.line, e.detail.quantity));
        this.addEventListener('submit', (e) => {
          const card = e.target.closest ? e.target.closest('[data-cross-sell]') : null;
          if (!card) return;
          e.preventDefault();
          this.addBottle(e.target);
        });
        this.addEventListener('click', (e) => {
          const btn = e.target.closest ? e.target.closest('[data-upsell-switch]') : null;
          if (btn) this.switchToSubscription(btn);
        });
        /* the script runs from the head: the lines are parsed after this element
           upgrades, so read them once the document is in */
        const parsed = () => { this.remember(); this.seedLocal(); };
        if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', parsed, { once: true }); else parsed();
        /* /cart renders the home sections with the drawer open over them (template-cart on Shopify, rp-open-cart in the preview) */
        if (document.body.classList.contains('rp-open-cart') || document.body.classList.contains('template-cart')) this.show({ animate: false });
      }

      /* preview only (data-local-renderer): the preview draws a fixture cart the
         session cart does not hold, so add the drawn lines once and the controls
         act on real lines. Never runs on Shopify */
      async seedLocal() {
        if (!this.hasAttribute('data-local-renderer')) return;
        const lines = Array.from(this.querySelectorAll('rp-line-item[data-line-key]'));
        if (!lines.length) return;
        try {
          const cart = await this.readCart();
          if (cart.item_count > 0) return;
          const items = lines.map((l) => ({ id: Number(l.dataset.variantId), quantity: Number(l.dataset.quantity || 1), ...(Number(l.dataset.plan) ? { selling_plan: Number(l.dataset.plan) } : { }) }));
          await this.post('/cart/add', { items });
        } catch (e) { /* the preview still renders; controls resync from the cart */ }
      }

      get open() { return this.hasAttribute('open'); }
      get controls() { return Array.from(document.querySelectorAll('[aria-controls="cart-drawer"]')); }
      get tabs() { return this.querySelector('rp-x-tabs'); }

      syncFooter() {
        const empty = this.footerSlot.assignedElements().length === 0;
        this.parts.footer.setAttribute('part', empty ? 'footer footer-empty' : 'footer');
      }

      /* what the cart held when last drawn, key to quantity: an add that only
         says "open" (no detail.added) is read against it */
      remember() {
        this.known = new Map(Array.from(this.querySelectorAll('rp-line-item[data-line-key]')).map((l) => [l.dataset.lineKey, Number(l.dataset.quantity || 0)]));
      }

      diff(cart) {
        return (cart.items || []).filter((i) => Number(i.quantity) > (this.known.get(i.key) || 0));
      }

      /* ---- cart:changed / rp:open-cart handling ---- */
      collect(kind, e) {
        const d = e.detail || { };
        if (kind === 'changed' && d.self) return;
        this.queue.push({ kind, e, d });
        if (!this.settleTimer) this.settleTimer = setTimeout(() => this.settle(), 0);
      }

      settle() {
        this.settleTimer = null;
        const q = this.queue;
        this.queue = [];
        const add = q.find((x) => x.kind === 'changed' && Array.isArray(x.d.added) && x.d.added.length);
        const opens = q.filter((x) => x.kind === 'open' && !x.e.defaultPrevented);
        const changed = q.some((x) => x.kind === 'changed');
        if (add) return this.confirm(add.d);
        /* an add confirmed a moment ago: a trailing open is the same add */
        if (Date.now() - this.confirmedAt < 1500 || this.confirming) { if (changed) this.sync(); return; }
        const legacy = opens.find((x) => x.d.cart && Array.isArray(x.d.cart.items));
        if (legacy) return this.confirm({ ...legacy.d.cart, source: legacy.d.source, added: this.diff(legacy.d.cart) });
        if (opens.length) {
          if (changed) this.sync();
          return this.show({ activator: this.pickOpener() });
        }
        if (changed) this.sync();
      }

      pickOpener() {
        const a = document.activeElement;
        if (a && a !== document.body && !this.contains(a)) return a;
        return this.lastControl && document.contains(this.lastControl) ? this.lastControl : null;
      }

      sectionId() {
        const wrap = this.closest('.shopify-section');
        return wrap && wrap.id ? wrap.id.replace(/^shopify-section-/, '') : 'rp-cart-drawer';
      }

      async fetchSection() {
        const id = this.sectionId();
        try {
          const r = await fetch(root() + '?sections=' + encodeURIComponent(id), { headers: { Accept: 'application/json' } });
          if (!r.ok) return null;
          return (await r.json())[id] || null;
        } catch (e) { return null; }
      }

      /* re-render quietly: one request at a time, in order */
      sync() {
        this.chain = this.chain.then(async () => {
          const html = await this.fetchSection();
          if (html) this.apply(html, { flip: this.open && !this.closing });
        });
        return this.chain;
      }

      /* an add: re-render, open, and let the added line arrive */
      confirm(d) {
        this.confirming = true;
        const opener = (d.opener && d.opener.isConnected ? d.opener : null) || this.pickOpener();
        this.chain = this.chain.then(async () => {
          const html = await this.fetchSection();
          const wasOpen = this.open && !this.closing;
          if (html) this.apply(html, { flip: wasOpen });
          if (this.tabs && this.tabs.selectedIndex > 0) this.tabs.select(0, false);
          const lines = this.linesFor(d.added || []);
          this.announce(d, lines);
          if (wasOpen) { this.reveal(lines); this.arrive(lines, 0); }
          else this.show({ activator: opener, arriving: lines });
          if (wasOpen) this.focusAfterAdd(lines);
          this.confirmedAt = Date.now();
          this.confirming = false;
        }).catch(() => { this.confirming = false; });
        return this.chain;
      }

      /* the drawn lines for the added cart lines: by key, else by variant and plan */
      linesFor(added) {
        const all = Array.from(this.querySelectorAll('rp-line-item[data-line-key]'));
        const out = [];
        for (const a of added) {
          let line = a.key ? all.find((l) => l.dataset.lineKey === String(a.key)) : null;
          if (!line) line = all.find((l) => Number(l.dataset.variantId) === Number(a.variant_id || a.id) && Number(l.dataset.plan || 0) === planOf(a));
          if (line && !out.includes(line)) out.push(line);
        }
        return out;
      }

      announce(d, lines) {
        const status = this.querySelector('[data-cart-status]');
        if (!status) return;
        const names = lines.map((l) => (l.querySelector('.line-item__title') || { }).textContent || '').map((s) => s.trim()).filter(Boolean);
        const text = names.length ? names.join(', ') + ' ' + (d.switched ? this.dataset.switchedLabel : this.dataset.addedLabel) : '';
        status.textContent = '';
        if (text) requestAnimationFrame(() => { status.textContent = text; });
      }

      /* swap in the store's render: the cart panel, the tab count and the
         footer. The tabs and the offers panel stay as they are. When the
         drawer is open, everything that stays moves to its new place with a
         transform (FLIP), so nothing inside the drawer jumps either */
      apply(html, { flip = false } = { }) {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const fresh = doc.querySelector('rp-cart-drawer');
        if (!fresh) return false;
        const before = flip ? this.measure() : null;
        const scroll = this.parts.body.scrollTop;
        const focusKey = document.activeElement && this.contains(document.activeElement) && document.activeElement.dataset ? document.activeElement.dataset.focusKey : null;
        const panel = this.querySelector('[data-cart-panel]');
        const nextPanel = fresh.querySelector('[data-cart-panel]');
        if (panel && nextPanel) {
          const keep = ['role', 'id', 'aria-labelledby', 'hidden', 'slot'];
          panel.className = nextPanel.className;
          for (const a of Array.from(nextPanel.attributes)) if (!keep.includes(a.name) && a.name !== 'class') panel.setAttribute(a.name, a.value);
          panel.innerHTML = nextPanel.innerHTML;
        }
        const label = this.querySelector('[data-cart-tab-label]');
        const nextLabel = fresh.querySelector('[data-cart-tab-label]');
        if (label && nextLabel) label.textContent = nextLabel.textContent;
        const footer = this.querySelector('[data-cart-footer]');
        const nextFooter = fresh.querySelector('[data-cart-footer]');
        if (footer && nextFooter) footer.innerHTML = nextFooter.innerHTML;
        else if (footer) footer.remove();
        else if (nextFooter) this.append(document.importNode(nextFooter, true));
        /* the offers panel stays; only the sample pack offer follows the cart */
        const offer = this.querySelector('[data-sample-offer]');
        const nextOffer = fresh.querySelector('[data-sample-offer]');
        if (offer && nextOffer) offer.hidden = nextOffer.hidden;
        this.parts.body.scrollTop = scroll;
        this.remember();
        if (before) this.flip(before);
        if (focusKey) {
          const back = this.querySelector('[data-focus-key="' + CSS.escape(focusKey) + '"]');
          if (back) back.focus({ preventScroll: true });
        }
        return true;
      }

      measure() {
        const m = new Map();
        for (const el of this.querySelectorAll('[data-flip]')) m.set(el.dataset.flip, el.getBoundingClientRect().top);
        return m;
      }

      /* what stayed slides from where it was; a row that is new (not a line,
         lines have their own arrival) fades in where it lands */
      flip(before) {
        if (reduceMotion()) return;
        for (const el of this.querySelectorAll('[data-flip]')) {
          if (!before.has(el.dataset.flip)) {
            if (el.localName !== 'rp-line-item') el.animate([{ opacity: 0 }, { opacity: 1 }], { duration: DUR(2), delay: DUR(1), easing: EASE('out'), fill: 'backwards' });
            continue;
          }
          const dy = before.get(el.dataset.flip) - el.getBoundingClientRect().top;
          if (Math.abs(dy) < 1) continue;
          el.animate([{ transform: 'translateY(' + dy + 'px)' }, { transform: 'none' }], { duration: DUR(3), easing: EASE('out') });
        }
      }

      /* the added line rises into place (emphasised ease) and the accent
         mark at its edge holds, then fades */
      arrive(lines, delay) {
        if (!lines.length || reduceMotion()) return;
        for (const line of lines) {
          line.animate([{ opacity: 0, transform: 'translateY(0.875rem)' }, { opacity: 1, transform: 'none' }], { duration: DUR(3), delay, easing: EASE('emph'), fill: 'backwards' });
          const wash = line.querySelector('.line-item__wash');
          if (wash) wash.animate([{ opacity: 0 }, { opacity: 1, offset: 0.15 }, { opacity: 1, offset: 0.7 }, { opacity: 0 }], { duration: DUR(4) * 3, delay, easing: 'ease-out' });
        }
      }

      /* the arriving line is always in view, before anything moves */
      reveal(lines) {
        const line = lines[0];
        if (!line) return;
        const body = this.parts.body;
        const b = body.getBoundingClientRect();
        const r = line.getBoundingClientRect();
        if (r.top < b.top || r.bottom > b.bottom) body.scrollTop += r.top - b.top - 16;
      }

      focusAfterAdd(lines) {
        if (this.contains(document.activeElement) && document.activeElement !== document.body) return;
        const title = lines[0] && lines[0].querySelector('.line-item__title');
        if (title) title.focus({ preventScroll: true });
        else this.parts['close-button'].focus({ preventScroll: true });
      }

      cancelAnimations() {
        for (const a of this.animations) a.cancel();
        this.animations = [];
      }

      lock(on) {
        const html = document.documentElement;
        if (on) {
          html.classList.toggle('rp-cart-lock--gutter', window.innerWidth > html.clientWidth);
          html.classList.add('rp-cart-lock');
        } else {
          html.classList.remove('rp-cart-lock', 'rp-cart-lock--gutter');
        }
      }

      show({ animate = true, activator, arriving = [] } = { }) {
        if (this.open && !this.closing) { this.arrive(arriving, 0); return; }
        this.cancelAnimations();
        this.closing = false;
        this.activator = activator || this.pickOpener();
        this.lock(true);
        this.setAttribute('open', '');
        for (const c of this.controls) c.setAttribute('aria-expanded', 'true');
        this.reveal(arriving);
        this.dispatchEvent(new CustomEvent('dialog:before-show', { bubbles: true }));
        const done = () => this.dispatchEvent(new CustomEvent('dialog:after-show', { bubbles: true }));
        if (animate && !reduceMotion()) {
          const d = DUR(3);
          this.animations = [
            this.parts.overlay.animate([{ opacity: 0 }, { opacity: 1 }], { duration: DUR(2), easing: EASE('out'), fill: 'both' }),
            this.parts.content.animate([{ transform: 'translateX(100%)' }, { transform: 'none' }], { duration: d, easing: EASE('out'), fill: 'both' }),
          ];
          Promise.all(this.animations.map((a) => a.finished)).then(() => { this.cancelAnimations(); done(); }, () => { });
          this.arrive(arriving, Math.round(d * 0.45));
        } else {
          done();
        }
        this.parts['close-button'].focus({ preventScroll: true });
      }

      hide() {
        if (!this.open || this.closing) return;
        this.closing = true;
        for (const c of this.controls) c.setAttribute('aria-expanded', 'false');
        this.dispatchEvent(new CustomEvent('dialog:before-hide', { bubbles: true }));
        const finish = () => {
          this.cancelAnimations();
          this.removeAttribute('open');
          this.closing = false;
          this.lock(false);
          this.dispatchEvent(new CustomEvent('dialog:after-hide', { bubbles: true }));
          /* focus goes back to the control that opened the drawer. A control
             that un-hides itself when the drawer closes (the sticky bar) may
             still be inert this frame, so try again for a few frames */
          const back = this.activator;
          this.activator = null;
          const refocus = (tries) => {
            if (!back || typeof back.focus !== 'function' || !document.contains(back)) return;
            back.focus({ preventScroll: true });
            if (document.activeElement !== back && tries > 0) requestAnimationFrame(() => refocus(tries - 1));
          };
          refocus(4);
        };
        this.cancelAnimations();
        if (reduceMotion()) return finish();
        this.animations = [
          this.parts.overlay.animate([{ opacity: 1 }, { opacity: 0 }], { duration: DUR(2), easing: EASE('in-out'), fill: 'both' }),
          this.parts.content.animate([{ transform: 'none' }, { transform: 'translateX(100%)' }], { duration: DUR(2), easing: EASE('in-out'), fill: 'both' }),
        ];
        Promise.all(this.animations.map((a) => a.finished)).then(finish, () => { });
      }

      /* the close button comes first in the shadow tree, then the light DOM in
         order; a roving tab (tabindex -1) is not a stop */
      tabbables() {
        const stop = (el) => el.tabIndex >= 0 && el.getClientRects().length > 0;
        return [this.parts['close-button'], ...Array.from(this.querySelectorAll(FOCUSABLE)).filter(stop)];
      }

      /* another dialog on top (the offer dialog opened from here) owns the keys */
      coveredBy(target) {
        const other = target && target.closest ? target.closest('dialog, [role="dialog"], [aria-modal="true"]') : null;
        if (other && other !== this) return true;
        try { return !!document.querySelector('dialog:modal'); } catch (e) { return false; }
      }

      onKeydown(e) {
        if (!this.open || this.closing) return;
        if (this.coveredBy(e.target)) return;
        if (e.key === 'Escape') { e.preventDefault(); this.hide(); return; }
        if (e.key !== 'Tab') return;
        const list = this.tabbables();
        if (!list.length) return;
        const first = list[0];
        const last = list[list.length - 1];
        const active = this.shadowRoot.activeElement || document.activeElement;
        const inside = this.contains(document.activeElement) || !!this.shadowRoot.activeElement;
        if (!inside) { e.preventDefault(); first.focus(); return; }
        if (e.shiftKey && active === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && active === last) { e.preventDefault(); first.focus(); }
      }

      /* ---- cart writes from inside the drawer ---- */
      async post(url, body) {
        const r = await fetch(url.replace(/\.js$/, '') + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: JSON.stringify(body) });
        if (!r.ok) throw new Error(String(r.status));
        return r.json();
      }

      async readCart() {
        const r = await fetch(root() + 'cart.js', { headers: { Accept: 'application/json' } });
        if (!r.ok) throw new Error(String(r.status));
        return r.json();
      }

      writeTotals(cart) {
        const total = this.querySelector('[data-cart-total]');
        if (total) total.textContent = formatMoney(cart.total_price, this.dataset.moneyFormat, this.dataset.currency);
        const label = this.querySelector('[data-cart-tab-label]');
        if (label) label.textContent = cart.item_count > 0 ? this.dataset.tabCart + ' (' + cart.item_count + ')' : this.dataset.tabCart;
      }

      /* quantity: the line updates at once, the store follows, and the
         store's answer is the one that stays */
      async onQuantity(line, quantity) {
        const key = line.dataset.lineKey;
        const error = line.querySelector('[data-line-error]');
        if (error) error.textContent = '';
        if (quantity <= 0) {
          this.removeLine(line);
        } else {
          line.dataset.quantity = String(quantity);
          const input = line.querySelector('input[data-line-key]');
          if (input && Number(input.value) !== quantity) input.value = quantity;
          line.querySelector('[data-line-price]').textContent = formatMoney(Number(line.dataset.unitPrice || 0) * quantity, this.dataset.moneyFormat);
          this.updateUpsell(key, quantity);
        }
        try {
          const cart = await this.post(this.dataset.changeUrl || '/cart/change', { id: key, quantity: Math.max(0, quantity) });
          this.writeTotals(cart);
          this.known = new Map((cart.items || []).map((i) => [i.key, Number(i.quantity)]));
          document.dispatchEvent(new CustomEvent('cart:changed', { detail: { ...cart, source: 'drawer', self: true } }));
          if (cart.item_count === 0 || quantity <= 0) this.sync();
        } catch (e) {
          this.sync();
        }
      }

      removeLine(line) {
        const key = line.dataset.lineKey;
        const gone = [line, this.querySelector('.rp-sub-upsell__item[data-line-key="' + CSS.escape(key) + '"]')].filter(Boolean);
        const finish = () => {
          const before = this.measure();
          for (const el of gone) el.remove();
          const wrap = this.querySelector('.rp-sub-upsell');
          if (wrap && !wrap.querySelector('.rp-sub-upsell__item')) wrap.remove();
          this.flip(before);
        };
        if (reduceMotion()) return finish();
        Promise.all(gone.map((el) => el.animate([{ opacity: 1 }, { opacity: 0 }], { duration: DUR(1), easing: EASE('out'), fill: 'forwards' }).finished)).then(finish, finish);
      }

      updateUpsell(key, quantity) {
        const item = this.querySelector('.rp-sub-upsell__item[data-line-key="' + CSS.escape(key) + '"]');
        if (!item) return;
        item.querySelector('[data-upsell-price]').textContent = formatMoney(Number(item.dataset.planPrice) * quantity, this.dataset.moneyFormat);
        item.querySelector('[data-upsell-badge]').textContent = item.dataset.saveLabel + ' ' + formatMoney(Number(item.dataset.planSaving) * quantity, this.dataset.moneyFormat);
      }

      /* a bottle row adds through RPCart.run (source 'upsell'); the resulting
         cart:changed is handled like any other add. Native submit without RPCart */
      addBottle(form) {
        const btn = form.querySelector('.rp-add');
        const id = Number(form.querySelector('[name="id"]').value);
        if (window.RPCart && btn) window.RPCart.run(btn, [{ id, quantity: 1 }], 'upsell');
        else form.submit();
      }

      /* the one-off line becomes a subscription line: /cart/change.js with
         the chosen selling plan, then cart:changed with the switched line */
      async switchToSubscription(btn) {
        if (btn.dataset.state === 'busy') return;
        const item = btn.closest('.rp-sub-upsell__item');
        const plan = Number(item.querySelector('[data-upsell-plan]').value);
        const line = this.querySelector('rp-line-item[data-line-key="' + CSS.escape(btn.dataset.lineKey) + '"]');
        const quantity = line ? Number(line.dataset.quantity) : 1;
        const state = (s) => (window.RPCart ? window.RPCart.state(btn, s) : (btn.dataset.state = s));
        state('busy');
        try {
          await this.post(this.dataset.changeUrl || '/cart/change', { id: btn.dataset.lineKey, quantity, selling_plan: plan });
          const cart = await this.readCart();
          state('done');
          const added = (cart.items || []).filter((i) => Number(i.variant_id) === Number(btn.dataset.variantId) && planOf(i) === plan);
          document.dispatchEvent(new CustomEvent('cart:changed', { detail: { ...cart, source: 'upsell', added, switched: true, opener: btn } }));
        } catch (e) {
          state('error');
          setTimeout(() => state('idle'), 2400);
        }
      }
    }
    if (!customElements.get('rp-cart-drawer')) customElements.define('rp-cart-drawer', CartDrawer);

    /* ---- <rp-x-tabs> ------------------------------------------------------- */
    let tabsUid = 0;
    class Tabs extends HTMLElement {
      constructor() {
        super();
        this.attachShadow({ mode: 'open' });
        this.shadowRoot.innerHTML = '<slot role="tablist" part="tab-list" name="tab"></slot><slot part="tab-panels" name="tabpanel"></slot>';
        this.uid = ++tabsUid;
        this.selectedIndex = -1;
      }

      /* the script runs from the head, so the element upgrades before its
         children are parsed: setup follows the slots */
      connectedCallback() {
        if (this.wired) return;
        this.wired = true;
        this.tabSlot = this.shadowRoot.querySelector('slot[name="tab"]');
        this.panelSlot = this.shadowRoot.querySelector('slot[name="tabpanel"]');
        this.shadowRoot.addEventListener('slotchange', () => this.setup());
        this.addEventListener('click', (e) => {
          const tab = e.target.closest ? e.target.closest('[role="tab"]') : null;
          const i = this.buttons ? this.buttons.indexOf(tab) : -1;
          if (i >= 0) this.select(i);
        });
        this.addEventListener('keydown', (e) => this.onKeydown(e));
        this.setup();
      }

      setup() {
        this.buttons = this.tabSlot.assignedElements();
        this.panels = this.panelSlot.assignedElements();
        if (!this.buttons.length) return;
        this.buttons.forEach((b, i) => {
          b.setAttribute('role', 'tab');
          if (!b.id) b.id = 'tab-' + this.uid + '-' + i;
          const p = this.panels[i];
          if (p) {
            p.setAttribute('role', 'tabpanel');
            if (!p.id) p.id = 'tab-panel-' + this.uid + '-' + i;
            b.setAttribute('aria-controls', p.id);
            p.setAttribute('aria-labelledby', b.id);
          }
        });
        this.select(this.selectedIndex >= 0 ? this.selectedIndex : parseInt(this.getAttribute('selected-index'), 10) || 0, false);
      }

      select(index, animate = true) {
        if (!this.buttons || !this.buttons.length) return;
        index = Math.min(Math.max(index, 0), this.buttons.length - 1);
        const prev = this.selectedIndex;
        this.selectedIndex = index;
        this.setAttribute('selected-index', String(index));
        this.buttons.forEach((b, i) => {
          b.setAttribute('aria-selected', i === index ? 'true' : 'false');
          if (i === index) b.removeAttribute('tabindex'); else b.tabIndex = -1;
        });
        const from = this.panels[prev];
        const to = this.panels[index];
        this.panels.forEach((p, i) => { p.hidden = i !== index; });
        if (prev === index || !animate || reduceMotion() || !from || !to) return;
        to.animate([{ opacity: 0, transform: 'translateY(0.5rem)' }, { opacity: 1, transform: 'none' }], { duration: DUR(2), easing: EASE('out') });
      }

      onKeydown(e) {
        const tab = e.target.closest ? e.target.closest('[role="tab"]') : null;
        const i = this.buttons ? this.buttons.indexOf(tab) : -1;
        if (i < 0) return;
        const map = { ArrowRight: i + 1, ArrowLeft: i - 1, Home: 0, End: this.buttons.length - 1 };
        if (!(e.key in map)) return;
        e.preventDefault();
        const next = (map[e.key] + this.buttons.length) % this.buttons.length;
        this.select(next);
        this.buttons[next].focus();
      }
    }
    if (!customElements.get('rp-x-tabs')) customElements.define('rp-x-tabs', Tabs);

    /* ---- <rp-line-item>: the steps, remove and the typed quantity ---------- */
    class LineItem extends HTMLElement {
      connectedCallback() {
        if (this.wired) return;
        this.wired = true;
        this.addEventListener('click', (e) => {
          const step = e.target.closest ? e.target.closest('[data-quantity-step]') : null;
          if (step) {
            const input = this.querySelector('input[data-line-key]');
            this.change(Math.max(0, (parseInt(input.value, 10) || 0) + Number(step.dataset.quantityStep)));
            return;
          }
          if (e.target.closest && e.target.closest('[data-remove-line]')) this.change(0);
        });
        this.addEventListener('change', (e) => {
          if (!e.target.matches('input[data-line-key]')) return;
          /* a typed quantity below 1, blank or not a number keeps the line as it was; Remove and minus take it out */
          const typed = Math.floor(Number(e.target.value));
          if (e.target.value.trim() === '' || !Number.isFinite(typed) || typed < 1) { e.target.value = this.dataset.quantity || 1; return; }
          this.change(typed);
        });
      }

      change(quantity) {
        this.dispatchEvent(new CustomEvent('line:quantity', { bubbles: true, detail: { line: this, quantity } }));
      }
    }
    if (!customElements.get('rp-line-item')) customElements.define('rp-line-item', LineItem);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rp-contact"] && !Shopify.designMode) return;
  try {
    
  /* Browser-side validation before the native post. An invalid field blocks the submit and takes focus;
     a valid form posts to Shopify, which emails the store and returns with the thank-you state. */
  (() => {
    const EMAIL = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const init = (form) => {
      const rules = {
        'contact[name]': (v) => v.trim() !== '',
        'contact[email]': (v) => v.trim() !== '' && EMAIL.test(v.trim()),
        'contact[body]': (v) => v.trim() !== '',
      };
      const fields = Object.keys(rules).map((name) => form.elements[name]).filter(Boolean);
      if (!fields.length) {
        /* the thank-you state: move focus to it so screen readers announce it */
        const success = form.querySelector('[data-ct-success]');
        if (success) { success.focus({ preventScroll: true }); success.scrollIntoView({ block: 'center' }); }
        return;
      }
      const errorFor = (input) => document.getElementById(input.getAttribute('aria-describedby'));
      const validate = (input) => {
        const ok = rules[input.name](input.value);
        input.setAttribute('aria-invalid', String(!ok));
        const err = errorFor(input);
        if (err) err.hidden = ok;
        return ok;
      };
      for (const input of fields) {
        input.addEventListener('blur', () => validate(input));
        input.addEventListener('input', () => { if (input.getAttribute('aria-invalid') === 'true') validate(input); });
      }
      form.addEventListener('submit', (e) => {
        let ok = true;
        for (const input of fields) { if (!validate(input)) ok = false; }
        if (!ok) { e.preventDefault(); fields.find((i) => i.getAttribute('aria-invalid') === 'true')?.focus(); }
      });
    };
    const start = () => { for (const form of document.querySelectorAll('form.rp-ct__form')) { if (form.dataset.rpCt) continue; form.dataset.rpCt = '1'; init(form); } };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
    else start();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rp-flavour-label"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const init = (root) => {
      for (const list of root.querySelectorAll('.rp-fl__tabs')) {
        if (list.dataset.ready) continue;
        list.dataset.ready = '1';
        const tabs = [...list.querySelectorAll('[role="tab"]')];
        const select = (tab, focus) => {
          for (const t of tabs) {
            const on = t === tab;
            t.setAttribute('aria-selected', String(on));
            t.tabIndex = on ? 0 : -1;
            const panel = document.getElementById(t.getAttribute('aria-controls'));
            if (panel) {
              panel.toggleAttribute('data-off', !on);
              panel.setAttribute('aria-hidden', String(!on));
              panel.inert = !on;
              const pack = panel.closest('.rp-fl__body')?.querySelector(`[data-fl-pack="${panel.dataset.flIndex}"]`);
              if (pack) { pack.toggleAttribute('data-off', !on); pack.setAttribute('aria-hidden', String(!on)); }
            }
          }
          if (focus) tab.focus();
        };
        list.addEventListener('click', (e) => { const t = e.target.closest('[role="tab"]'); if (t) select(t, false); });
        list.addEventListener('keydown', (e) => {
          const i = tabs.indexOf(document.activeElement);
          if (i < 0) return;
          let next = null;
          if (e.key === 'ArrowRight') next = tabs[(i + 1) % tabs.length];
          if (e.key === 'ArrowLeft') next = tabs[(i - 1 + tabs.length) % tabs.length];
          if (e.key === 'Home') next = tabs[0];
          if (e.key === 'End') next = tabs[tabs.length - 1];
          if (next) { e.preventDefault(); select(next, true); }
        });
      }
    };
    const boot = () => init(document);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
    else boot();
    document.addEventListener('shopify:section:load', (e) => init(e.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rp-how-to"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const init = (root) => {
      if (root.dataset.howtoReady) return;
      root.dataset.howtoReady = 'true';
      const tags = [...root.querySelectorAll('[data-howto-tag]')];
      const descs = [...root.querySelectorAll('[data-howto-desc]')];
      const fallback = root.querySelector('[data-howto-default-desc]');
      const images = [...root.querySelectorAll('.rp-howto__media img')];
      const activate = (index) => {
        tags.forEach((tag, i) => tag.setAttribute('aria-pressed', String(i === index)));
        descs.forEach((desc, i) => {
          desc.classList.toggle('is-active', i === index);
          desc.setAttribute('aria-hidden', String(i !== index));
        });
        if (fallback) {
          fallback.classList.remove('is-active');
          fallback.setAttribute('aria-hidden', 'true');
        }
        images.forEach((img, i) => img.classList.toggle('is-active', i === index));
      };
      tags.forEach((tag, i) => tag.addEventListener('click', () => activate(i)));
      if (tags.length) activate(0);
    };
    const boot = (scope) => scope.querySelectorAll('.rp-howto').forEach(init);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => boot(document), { once: true });
    else boot(document);
    document.addEventListener('shopify:section:load', (event) => boot(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rp-learn-hero"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const norm = (s) => s.toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim();

    const point = () => {
      const sections = [...document.querySelectorAll('main > .shopify-section')];
      for (const a of document.querySelectorAll('.rp-lh__link[data-lh-target]')) {
        const want = a.dataset.lhTarget.trim();
        if (!want) continue;
        const key = norm(want);
        const target =
          sections.find((s) => s.id === want || s.id.endsWith('__' + want)) ||
          sections.find((s) => [...s.querySelectorAll('h1, h2, .rp-heading')].some((h) => norm(h.textContent).startsWith(key)));
        if (target && !target.contains(a)) a.setAttribute('href', '#' + target.id);
      }
    };

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', point);
    else point();
    document.addEventListener('shopify:section:load', point);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rp-learn-minerals"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

    const arm = () => {
      if (reduce.matches || !('IntersectionObserver' in window)) return;
      const values = document.querySelectorAll('.rp-lm__value[data-lm-count]:not(.is-armed)');
      if (!values.length) return;
      const io = new IntersectionObserver((entries) => {
        for (const e of entries) {
          if (!e.isIntersecting) continue;
          io.unobserve(e.target);
          const el = e.target;
          const end = parseInt(el.dataset.lmCount, 10);
          // Wait for the section reveal so the count plays where it can be seen.
          const go = () => {
            const section = el.closest('.rp-reveal');
            if (section && !section.classList.contains('is-revealed')) return requestAnimationFrame(go);
            const start = performance.now() + 250;
            const tick = (now) => {
              const t = Math.min(1, Math.max(0, (now - start) / 1300));
              el.textContent = String(Math.round(end * (1 - Math.pow(1 - t, 3))));
              if (t < 1) requestAnimationFrame(tick);
              else el.textContent = el.dataset.lmCount;
            };
            requestAnimationFrame(tick);
          };
          go();
        }
      }, { threshold: 0.6 });
      for (const el of values) {
        // only plain whole numbers count up; anything else ("1.5", "800+") stays as typed
        if (!/^\d{1,6}$/.test(el.dataset.lmCount)) continue;
        el.classList.add('is-armed');
        el.textContent = '0';
        io.observe(el);
      }
    };

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', arm);
    else arm();
    document.addEventListener('shopify:section:load', arm);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rp-main-product"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var reduceMotion = function () { return window.matchMedia('(prefers-reduced-motion: reduce)').matches; };
    var money = function (cents) { return '$' + (Number(cents || 0) / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ','); };
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

    /* Shopify answers an items add with the added lines; if a full cart comes
       back instead (the local preview server), pick the lines by variant and plan */
    var addedLines = function (added, cart, item) {
      if (added && Array.isArray(added.items) && added.item_count === undefined) return added.items;
      if (added && added.variant_id) return [added];
      return (cart.items || []).filter(function (l) {
        if (Number(l.variant_id) !== item.id) return false;
        var a = l.selling_plan_allocation, plan = a ? Number(a.selling_plan_id || (a.selling_plan && a.selling_plan.id)) : null;
        return item.selling_plan ? plan === item.selling_plan : !plan;
      });
    };

    /* the add button's label stack: idle, adding, added. The size never changes */
    var setAtc = function (button, state) {
      if (!button) return;
      button.setAttribute('data-atc-state', state);
      button.setAttribute('aria-busy', state === 'adding' ? 'true' : 'false');
      button.querySelectorAll('.rp-atc__label').forEach(function (l) { l.setAttribute('aria-hidden', l.getAttribute('data-state') === state ? 'false' : 'true'); });
    };

    /* the elements are defined once the DOM is parsed: this script runs from
       the head, and an element upgraded mid-parse has no children yet */
    var defineElements = function () {
    /* <rp-scroll-carousel>: a snap scroller that knows which cell is centred. */
    if (!customElements.get('rp-scroll-carousel')) {
      customElements.define('rp-scroll-carousel', class extends HTMLElement {
        connectedCallback() {
          this.selectedIndex = Math.max(0, this.cells.findIndex(function (c) { return c.classList.contains('is-initial'); }));
          this.addEventListener('scroll', this.onScroll.bind(this), { passive: true });
          this.addEventListener('keydown', this.onKeydown.bind(this));
        }
        get cells() { return Array.from(this.children).filter(function (c) { return !c.hasAttribute('hidden'); }); }
        get selectedCell() { return this.cells[this.selectedIndex]; }
        closestIndex() {
          var mid = this.scrollLeft + this.clientWidth / 2, best = 0, dist = Infinity;
          this.cells.forEach(function (cell, i) {
            var d = Math.abs(cell.offsetLeft + cell.clientWidth / 2 - mid);
            if (d < dist) { dist = d; best = i; }
          });
          return best;
        }
        onScroll() {
          if (this.raf || this.pinned) return;
          this.raf = requestAnimationFrame(function () {
            this.raf = null;
            var i = this.closestIndex();
            if (i !== this.selectedIndex) { this.selectedIndex = i; this.dispatchEvent(new CustomEvent('carousel:change', { bubbles: true, detail: { index: i, cell: this.cells[i] } })); }
          }.bind(this));
        }
        onKeydown(e) {
          if (e.target !== this) return;
          if (e.key === 'ArrowRight') { e.preventDefault(); this.next(); }
          else if (e.key === 'ArrowLeft') { e.preventDefault(); this.previous(); }
          else if (e.key === 'Home') { e.preventDefault(); this.select(0); }
          else if (e.key === 'End') { e.preventDefault(); this.select(this.cells.length - 1); }
        }
        select(index, opts) {
          var cells = this.cells;
          if (!(index in cells)) return;
          var cell = cells[index];
          var left = cell.offsetLeft - (this.clientWidth - cell.clientWidth) / 2;
          left = Math.max(0, Math.min(left, this.scrollWidth - this.clientWidth));
          if (index !== this.selectedIndex) { this.selectedIndex = index; this.dispatchEvent(new CustomEvent('carousel:change', { bubbles: true, detail: { index: index, cell: cell } })); }
          var instant = (opts && opts.instant) || reduceMotion();
          /* an instant jump must not be re-read mid-scroll as a different cell */
          if (instant) { this.pinned = true; this.scrollTo({ left: left, behavior: 'instant' }); var self = this; requestAnimationFrame(function () { self.pinned = false; }); }
          else this.scrollTo({ left: left, behavior: 'smooth' });
        }
        next() { this.select(Math.min(this.selectedIndex + 1, this.cells.length - 1)); }
        previous() { this.select(Math.max(this.selectedIndex - 1, 0)); }
      });
    }

    /* <rp-carousel-navigation aria-controls>: thumbnails, aria-current follows the carousel. */
    if (!customElements.get('rp-carousel-navigation')) {
      customElements.define('rp-carousel-navigation', class extends HTMLElement {
        connectedCallback() {
          var carousel = this.carousel; if (!carousel) return;
          this.items = Array.from(this.querySelectorAll('button'));
          this.items.forEach(function (b, i) { b.addEventListener('click', function () { carousel.select(i); }); });
          carousel.addEventListener('carousel:change', function (e) { this.update(e.detail.index); }.bind(this));
          this.update(carousel.selectedIndex || 0);
        }
        get carousel() { return document.getElementById(this.getAttribute('aria-controls')); }
        update(index) {
          this.items.forEach(function (b, i) { b.setAttribute('aria-current', i === index ? 'true' : 'false'); });
          var item = this.items[index];
          if (item && this.hasAttribute('align-selected') && this.scrollWidth > this.clientWidth) {
            this.scrollTo({ left: item.offsetLeft - this.clientWidth / 2 + item.clientWidth / 2, behavior: reduceMotion() ? 'auto' : 'smooth' });
          }
        }
      });
    }

    /* <rp-open-lightbox-button>: asks the gallery for the zoom. */
    if (!customElements.get('rp-open-lightbox-button')) {
      customElements.define('rp-open-lightbox-button', class extends HTMLElement {
        connectedCallback() { this.addEventListener('click', function (e) { this.dispatchEvent(new CustomEvent('lightbox:open', { bubbles: true, detail: { opener: e.target.closest('button') } })); }.bind(this)); }
      });
    }

    /* <rp-zoom>: the contained zoom. A full-viewport transparent dialog holds a
       scrim and a panel smaller than the viewport. Open grows the image from
       its source rect (FLIP); close returns it there. Transform and opacity only. */
    if (!customElements.get('rp-zoom')) {
      customElements.define('rp-zoom', class extends HTMLElement {
        connectedCallback() {
          this.dialog = this.querySelector('dialog');
          if (!this.dialog || this.ready) return;
          this.ready = true;
          this.stage = this.dialog.querySelector('[data-zoom-stage]');
          this.img = this.dialog.querySelector('[data-zoom-img]');
          this.panel = this.dialog.querySelector('.rp-zoom__panel');
          this.sheet = this.dialog.querySelector('.rp-zoom__sheet');
          this.scrim = this.dialog.querySelector('.rp-zoom__scrim');
          this.levels = [1, 1.5, 2, 3];
          this.level = 0;
          this.index = 0;
          var self = this, d = this.dialog;
          d.querySelectorAll('[data-zoom-close]').forEach(function (b) { b.addEventListener('click', function () { self.close(); }); });
          d.querySelectorAll('[data-zoom-step]').forEach(function (b) { b.addEventListener('click', function () { self.step(Number(b.getAttribute('data-zoom-step'))); }); });
          d.querySelectorAll('[data-zoom]').forEach(function (b) { b.addEventListener('click', function () { self.setLevel(self.level + Number(b.getAttribute('data-zoom'))); }); });
          d.addEventListener('keydown', function (e) { self.onKeydown(e); });
          /* a close the browser forces (a second Escape) still cleans up */
          d.addEventListener('cancel', function (e) { e.preventDefault(); self.close(); });
          d.addEventListener('close', function () { self.finish(); });
          this.stage.addEventListener('click', function (e) {
            if (self.swiped) { self.swiped = false; return; }
            if (self.dragged) { self.dragged = false; return; }
            if (!e.target.closest('[data-zoom-img]')) return;
            var r = self.img.getBoundingClientRect();
            self.setLevel(self.level > 0 ? 0 : 2, (e.clientX - r.left) / r.width, (e.clientY - r.top) / r.height);
          });
          var start = null;
          this.stage.addEventListener('pointerdown', function (e) { start = self.level === 0 && e.isPrimary ? { x: e.clientX, y: e.clientY } : null; });
          this.stage.addEventListener('pointerup', function (e) {
            if (!start) return;
            var dx = e.clientX - start.x, dy = e.clientY - start.y;
            start = null;
            if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) * 1.2) { self.swiped = true; self.step(dx < 0 ? 1 : -1); }
          });
          this.stage.addEventListener('pointercancel', function () { start = null; });
          /* zoomed, a mouse drags the picture around (touch scrolls natively) */
          var drag = null;
          this.stage.addEventListener('pointerdown', function (e) {
            if (self.level === 0 || e.pointerType !== 'mouse' || e.button !== 0) return;
            e.preventDefault();
            drag = { x: e.clientX, y: e.clientY, l: self.stage.scrollLeft, t: self.stage.scrollTop, moved: false, id: e.pointerId };
          });
          this.stage.addEventListener('pointermove', function (e) {
            if (!drag) return;
            var dx = e.clientX - drag.x, dy = e.clientY - drag.y;
            /* capture only once it is a drag: captured from the press, a plain click would land on the stage, not the image */
            if (!drag.moved && Math.abs(dx) + Math.abs(dy) > 4) { drag.moved = true; self.stage.classList.add('is-dragging'); self.stage.setPointerCapture(drag.id); }
            if (drag.moved) { self.stage.scrollLeft = drag.l - dx; self.stage.scrollTop = drag.t - dy; }
          });
          var endDrag = function () {
            if (!drag) return;
            if (drag.moved) self.dragged = true;
            if (self.stage.hasPointerCapture && self.stage.hasPointerCapture(drag.id)) self.stage.releasePointerCapture(drag.id);
            drag = null;
            self.stage.classList.remove('is-dragging');
          };
          this.stage.addEventListener('pointerup', endDrag);
          this.stage.addEventListener('pointercancel', endDrag);
          /* a trackpad pinch (wheel + ctrlKey) or ctrl + scroll steps the zoom at the pointer */
          var pinch = 0;
          this.stage.addEventListener('wheel', function (e) {
            if (!e.ctrlKey) return;
            e.preventDefault();
            pinch += e.deltaY;
            if (Math.abs(pinch) < 40) return;
            var r = self.img.getBoundingClientRect();
            self.setLevel(self.level + (pinch < 0 ? 1 : -1), (e.clientX - r.left) / r.width, (e.clientY - r.top) / r.height);
            pinch = 0;
          }, { passive: false });
          /* the stage can lay out after the first measure (or change size later): fit again */
          if ('ResizeObserver' in window) {
            this.ro = new ResizeObserver(function () { if (self.dialog.open) self.setLevel(self.level); });
            this.ro.observe(this.stage);
          }
        }
        get carousel() { return document.getElementById(this.getAttribute('data-carousel')); }
        get cells() { var c = this.carousel; return c ? c.cells : []; }
        sourceImg(i) { var cell = this.cells[i]; return cell && cell.querySelector('img'); }
        chrome() { return Array.from(this.dialog.querySelectorAll('[data-zoom-chrome]')); }
        show(i, opts) {
          var cell = this.cells[i]; if (!cell) return;
          var src = this.sourceImg(i);
          this.index = i;
          this.img.width = Number(cell.getAttribute('data-width')) || 1;
          this.img.height = Number(cell.getAttribute('data-height')) || 1;
          /* the shape comes from the cell, never from img.width: that reads the rendered size, which is the previous image's */
          this.ratio = (Number(cell.getAttribute('data-width')) || 1) / (Number(cell.getAttribute('data-height')) || 1);
          this.img.alt = (src && src.alt) || '';
          /* the carousel's own file is already loaded, so the image is there at once; the large file swaps in when decoded */
          var now = src && (src.currentSrc || src.src);
          if (now) this.img.src = now;
          var big = cell.getAttribute('data-zoom-src'), self = this, token = (this.token = {});
          if (big && big !== now) { var pre = new Image(); pre.src = big; (pre.decode ? pre.decode() : Promise.resolve()).then(function () { if (self.token === token) self.img.src = big; }, function () {}); }
          var total = this.cells.length;
          this.dialog.querySelector('[data-zoom-counter]').textContent = this.single ? (this.img.alt || '') : (i + 1) + ' / ' + total;
          var prev = this.dialog.querySelector('[data-zoom-step="-1"]'), next = this.dialog.querySelector('[data-zoom-step="1"]');
          if (prev) prev.disabled = i === 0;
          if (next) next.disabled = i === total - 1;
          if (opts && opts.announce) this.dialog.querySelector('[data-zoom-live]').textContent = 'Image ' + (i + 1) + ' of ' + total + (this.img.alt ? ', ' + this.img.alt : '');
          this.setLevel(0);
        }
        step(dir) {
          var i = this.index + dir;
          if (this.single || i < 0 || i >= this.cells.length || this.closing) return;
          this.show(i, { announce: true });
          if (this.carousel) this.carousel.select(i, { instant: true });
          if (!reduceMotion()) this.img.animate([{ opacity: 0, transform: 'translateX(' + (dir * 24) + 'px)' }, { opacity: 1, transform: 'none' }], { duration: 360, easing: 'cubic-bezier(0.4, 0, 0.22, 1)' });
        }
        setLevel(i, fx, fy) {
          var stage = this.stage, img = this.img;
          /* the buttons, keys and a resize keep the middle of the view where it was */
          var prevW = parseFloat(img.style.width) || 0, prevH = parseFloat(img.style.height) || 0;
          if (fx === undefined && this.level > 0 && prevW && prevH) {
            fx = (stage.scrollLeft + stage.clientWidth / 2) / prevW;
            fy = (stage.scrollTop + stage.clientHeight / 2) / prevH;
          }
          this.level = Math.max(0, Math.min(this.levels.length - 1, i));
          var z = this.levels[this.level];
          fx = fx === undefined ? 0.5 : Math.max(0, Math.min(1, fx)); fy = fy === undefined ? 0.5 : Math.max(0, Math.min(1, fy));
          /* the fitted size, then the level: a discrete step, never animated */
          var fit = this.fit();
          stage.classList.toggle('is-zoomed', this.level > 0);
          if (fit) {
            var w = Math.round(fit.w * z), h = Math.round(fit.h * z);
            img.style.width = w + 'px';
            img.style.height = h + 'px';
            if (this.level > 0) {
              stage.scrollLeft = Math.max(0, w * fx - stage.clientWidth / 2);
              stage.scrollTop = Math.max(0, h * fy - stage.clientHeight / 2);
            }
          }
          var out = this.dialog.querySelector('[data-zoom-level]'); if (out) out.textContent = Math.round(z * 100) + '%';
          var minus = this.dialog.querySelector('[data-zoom="-1"]'), plus = this.dialog.querySelector('[data-zoom="1"]');
          if (minus) minus.disabled = this.level === 0;
          if (plus) plus.disabled = this.level === this.levels.length - 1;
        }
        fit() {
          var s = this.stage, ratio = this.ratio || (this.img.width / this.img.height);
          if (!s.clientWidth || !s.clientHeight || !ratio) return null;
          var w = Math.min(s.clientWidth, s.clientHeight * ratio);
          return { w: w, h: w / ratio };
        }
        /* the page holds still behind the zoom: no scroll, no width change */
        lock() {
          var html = document.documentElement, self = this;
          this.savedY = window.scrollY;
          html.classList.add('rp-zoom-lock');
          html.classList.toggle('rp-zoom-lock--overlay', window.innerWidth - html.clientWidth === 0);
          if (!this.block) {
            /* only a zoomed stage may scroll; everything else is held */
            this.block = function (e) { if (self.level > 0 && self.stage.contains(e.target)) return; if (e.cancelable) e.preventDefault(); };
            this.hold = function () { if (window.scrollY !== self.savedY) window.scrollTo({ top: self.savedY, behavior: 'instant' }); };
          }
          window.addEventListener('wheel', this.block, { passive: false });
          window.addEventListener('touchmove', this.block, { passive: false });
          window.addEventListener('scroll', this.hold, { passive: true });
        }
        unlock() {
          document.documentElement.classList.remove('rp-zoom-lock', 'rp-zoom-lock--overlay');
          if (!this.block) return;
          window.removeEventListener('wheel', this.block, { passive: false });
          window.removeEventListener('touchmove', this.block, { passive: false });
          window.removeEventListener('scroll', this.hold, { passive: true });
        }
        /* where the image flies from and back to: the carousel image when it is on screen */
        sourceRect(i) {
          var img = this.sourceImg(i); if (!img) return null;
          var r = img.getBoundingClientRect();
          var visible = r.width > 20 && r.bottom > 0 && r.top < window.innerHeight && r.right > 0 && r.left < window.innerWidth;
          if (!visible) return null;
          var cover = getComputedStyle(img).objectFit === 'cover';
          return { rect: r, cover: cover };
        }
        flip(from, to, cover) {
          var sx = from.width / to.width, sy = from.height / to.height;
          var s = cover ? Math.max(sx, sy) : Math.min(sx, sy);
          var tx = (from.left + from.width / 2) - (to.left + to.width / 2);
          var ty = (from.top + from.height / 2) - (to.top + to.height / 2);
          return 'translate(' + tx.toFixed(1) + 'px, ' + ty.toFixed(1) + 'px) scale(' + s.toFixed(4) + ')';
        }
        /* opts.single: the nutrition label opens on its own: no arrows, no arrow keys, no swipe,
           and the image's alt in place of the counter */
        open(i, opener, opts) {
          if (this.dialog.open) return;
          this.opener = opener || document.activeElement;
          this.closing = false;
          this.single = !!(opts && opts.single);
          this.dialog.toggleAttribute('data-single', this.single);
          this.show(i);
          this.lock();
          this.dialog.showModal();
          this.setLevel(0);
          if (!this.onResize) { var self = this; this.onResize = function () { if (self.dialog.open) self.setLevel(self.level); }; window.addEventListener('resize', this.onResize); }
          if (this.opener && this.opener.hasAttribute('aria-expanded')) this.opener.setAttribute('aria-expanded', 'true');
          var close = this.dialog.querySelector('.rp-zoom__close');
          if (close) close.focus({ preventScroll: true });
          if (reduceMotion()) return;
          var ease = 'cubic-bezier(0.4, 0, 0.22, 1)', dur = 440;
          var to = this.img.getBoundingClientRect(), src = this.sourceRect(i);
          this.anims = [
            this.scrim.animate([{ opacity: 0 }, { opacity: 1 }], { duration: dur, easing: ease }),
            this.sheet.animate([{ opacity: 0, transform: 'scale(0.97)' }, { opacity: 1, transform: 'none' }], { duration: dur, easing: ease }),
            src
              ? this.img.animate([{ transform: this.flip(src.rect, to, src.cover) }, { transform: 'none' }], { duration: dur, easing: ease })
              : this.img.animate([{ opacity: 0, transform: 'scale(0.94)' }, { opacity: 1, transform: 'none' }], { duration: dur, easing: ease })
          ].concat(this.chrome().map(function (el) { return el.animate([{ opacity: 0 }, { opacity: 1 }], { duration: 300, easing: ease }); }));
        }
        close() {
          if (!this.dialog.open || this.closing) return;
          this.closing = true;
          (this.anims || []).forEach(function (a) { a.cancel(); });
          var self = this, done = function () { if (self.dialog.open) self.dialog.close(); };
          if (reduceMotion()) return done();
          if (this.level > 0) this.setLevel(0);
          var ease = 'cubic-bezier(0.4, 0, 0.22, 1)', dur = 380, fill = 'forwards';
          var from = this.img.getBoundingClientRect(), dst = this.sourceRect(this.index);
          var anims = [
            this.scrim.animate([{ opacity: 1 }, { opacity: 0 }], { duration: dur, easing: ease, fill: fill }),
            this.sheet.animate([{ opacity: 1, transform: 'none' }, { opacity: 0, transform: 'scale(0.97)' }], { duration: dur, easing: ease, fill: fill }),
            dst
              ? this.img.animate([{ transform: 'none' }, { transform: this.flip(dst.rect, from, dst.cover) }], { duration: dur, easing: ease, fill: fill })
              : this.img.animate([{ opacity: 1, transform: 'none' }, { opacity: 0, transform: 'scale(0.94)' }], { duration: dur, easing: ease, fill: fill })
          ].concat(this.chrome().map(function (el) { return el.animate([{ opacity: 1 }, { opacity: 0 }], { duration: 160, easing: ease, fill: fill }); }));
          this.anims = anims;
          Promise.all(anims.map(function (a) { return a.finished; })).then(done, done);
        }
        finish() {
          (this.anims || []).forEach(function (a) { a.cancel(); });
          this.anims = null;
          this.closing = false;
          this.token = null;
          this.unlock();
          this.setLevel(0);
          var back = this.opener;
          this.opener = null;
          if (back && back.hasAttribute && back.hasAttribute('aria-expanded')) back.setAttribute('aria-expanded', 'false');
          if (back && document.contains(back) && back.focus) back.focus({ preventScroll: true });
        }
        onKeydown(e) {
          if (e.key === 'Escape') { e.preventDefault(); this.close(); return; }
          if (e.key === 'ArrowRight') { e.preventDefault(); this.step(1); return; }
          if (e.key === 'ArrowLeft') { e.preventDefault(); this.step(-1); return; }
          if (e.key === '+' || e.key === '=') { e.preventDefault(); this.setLevel(this.level + 1); return; }
          if (e.key === '-') { e.preventDefault(); this.setLevel(this.level - 1); return; }
          /* scroll keys never reach the page behind */
          if (['PageUp', 'PageDown', 'Home', 'End', 'ArrowUp', 'ArrowDown'].indexOf(e.key) > -1 || (e.key === ' ' && !e.target.closest('button'))) {
            if (!(this.level > 0 && this.stage.contains(e.target))) e.preventDefault();
            return;
          }
          if (e.key !== 'Tab') return;
          /* focus stays inside the panel */
          var list = Array.from(this.dialog.querySelectorAll(FOCUSABLE)).filter(function (el) { return el.getClientRects().length > 0; });
          if (!list.length) return;
          var first = list[0], last = list[list.length - 1];
          if (e.shiftKey && (document.activeElement === first || !this.dialog.contains(document.activeElement))) { e.preventDefault(); last.focus(); }
          else if (!e.shiftKey && (document.activeElement === last || !this.dialog.contains(document.activeElement))) { e.preventDefault(); first.focus(); }
        }
      });
    }

    /* <rp-product-gallery>: the cursor, the click halves, the variant sync and the zoom. */
    if (!customElements.get('rp-product-gallery')) {
      customElements.define('rp-product-gallery', class extends HTMLElement {
        connectedCallback() {
          var carousel = this.carousel; if (!carousel) return;
          var self = this, frame = carousel.parentElement, cursor = this.querySelector('.rp-custom-cursor');
          var fine = window.matchMedia('(pointer: fine)');
          if (cursor && fine.matches) {
            frame.addEventListener('pointermove', function (e) {
              if (e.target.closest('.rp-product-zoom-button')) { cursor.classList.remove('rp-is-visible'); return; }
              var r = frame.getBoundingClientRect(), x = e.clientX - r.left, y = e.clientY - r.top;
              cursor.style.translate = (x - 20) + 'px ' + (y - 20) + 'px';
              cursor.classList.add('rp-is-visible');
              cursor.classList.toggle('rp-is-half-start', x < r.width / 2);
            });
            frame.addEventListener('pointerleave', function () { cursor.classList.remove('rp-is-visible'); });
          }
          /* a fine pointer steps through the halves; a tap opens the zoom */
          carousel.addEventListener('click', function (e) {
            if (fine.matches) {
              var r = carousel.getBoundingClientRect();
              if (e.clientX - r.left < r.width / 2) carousel.previous(); else carousel.next();
              return;
            }
            var cell = e.target.closest('.rp-product-gallery__media');
            var index = cell ? carousel.cells.indexOf(cell) : carousel.selectedIndex;
            if (index > -1) self.openZoom(index, carousel);
          });
          var form = document.forms[this.getAttribute('form')];
          if (form) form.addEventListener('variant:change', function (e) {
            var id = self.mediaFor(e.detail && e.detail.variant);
            if (!id) return;
            var index = carousel.cells.findIndex(function (c) { return c.getAttribute('data-media-id') === String(id); });
            if (index > -1 && index !== carousel.selectedIndex) carousel.select(index, { instant: !!(e.detail && e.detail.initial) });
          });
          this.addEventListener('lightbox:open', function (e) { self.openZoom(carousel.selectedIndex, e.detail && e.detail.opener); });
          var section = this.closest('.shopify-section');
          if (section) section.querySelectorAll('.rp-nutritional-info__link[data-zoom-index]').forEach(function (b) {
            b.addEventListener('click', function () { self.openZoom(Number(b.getAttribute('data-zoom-index')), b, { single: true }); });
          });
        }
        get carousel() { return this.querySelector('.rp-product-gallery__carousel'); }
        get zoom() { var d = document.getElementById(this.getAttribute('data-zoom')); return d && d.closest('rp-zoom'); }
        /* the gallery follows the picked flavour: a picture several flavours share
           (a line-up shot) gives way to the flavour's own pack shot */
        mediaFor(v) {
          if (!v) return null;
          var w = this.closest('.shopify-section').querySelector('subscription-widget-v2'), list = (w && w.variants) || [];
          var shared = function (id) { return new Set(list.filter(function (x) { return x.media_id === id; }).map(function (x) { return x.flavour; })).size > 1; };
          if (!shared(v.media_id)) return v.media_id;
          var own = list.find(function (x) { return x.flavour === v.flavour && x.media_id && !shared(x.media_id); });
          return own ? own.media_id : v.media_id;
        }
        openZoom(index, opener, opts) {
          var zoom = this.zoom; if (!zoom) return;
          var carousel = this.carousel;
          /* the label opens on its own; the gallery stays on the photo the shopper was looking at */
          if (carousel && index !== carousel.selectedIndex && !(opts && opts.single)) carousel.select(index, { instant: true });
          zoom.open(index, opener, opts);
        }
      });
    }

    /* <subscription-widget-v2>: plan, servings and flavour pick one variant. */
    if (!customElements.get('subscription-widget-v2')) {
      customElements.define('subscription-widget-v2', class extends HTMLElement {
        connectedCallback() {
          var data = this.querySelector('script[data-rp-variants]');
          this.variants = data ? JSON.parse(data.textContent) : [];
          this.form = document.forms[this.getAttribute('form-id')];
          this.section = this.closest('.shopify-section');
          this.wantsSubscription = !!this.querySelector('input[name="purchase_option"][value="subscription"]:checked');
          var self = this;
          this.querySelectorAll('input[name="purchase_option"]').forEach(function (input) {
            input.addEventListener('change', function () {
              self.wantsSubscription = input.value === 'subscription';
              /* a size with no plan (the 12-serve packs): subscribing moves to the size that has one */
              if (self.wantsSubscription && !self.plan) self.toPlanned();
              self.render();
            });
          });
          this.querySelectorAll('.subscription-widget__tier-tab').forEach(function (tab) {
            tab.addEventListener('click', function () { self.servings = tab.getAttribute('data-servings'); self.render(); });
          });
          this.querySelectorAll('.subscription-widget__flavour-grid input[type="radio"]').forEach(function (input) {
            input.addEventListener('change', function () { self.render(); });
          });
          var select = this.querySelector('[data-rp-plan]');
          if (select) select.addEventListener('change', function () { self.render(); });
          /* ?selling_plan= from a subscribe link: open the subscription on that plan */
          try {
            var wanted = new URL(window.location.href).searchParams.get('selling_plan');
            if (wanted && select && select.querySelector('option[value="' + wanted + '"]')) { select.value = wanted; this.wantsSubscription = true; }
          } catch (err) { /* sandboxed url */ }
          /* Subscribe instead: on a plan variant it subscribes; on a variant with no plan it moves to the servings that have one */
          var instead = this.querySelector('[data-rp-subscribe-instead]');
          if (instead) instead.addEventListener('click', function () {
            if (!self.plan) self.toPlanned();
            self.wantsSubscription = true;
            self.render();
            var sub = self.querySelector('input[name="purchase_option"][value="subscription"]');
            if (sub) sub.focus({ preventScroll: true });
          });
          var active = this.querySelector('.subscription-widget__tier-tab--active');
          this.servings = active ? active.getAttribute('data-servings') : (this.variants[0] && this.variants[0].servings);
          this.render(true);
        }
        /* this flavour's variant that has a plan, else any variant that has one */
        get planned() {
          var f = this.flavour;
          return this.variants.find(function (x) { return x.flavour === f && x.plans.length; }) || this.variants.find(function (x) { return x.plans.length; });
        }
        toPlanned() { var p = this.planned; if (p) this.servings = p.servings; }
        get flavour() { var c = this.querySelector('.subscription-widget__flavour-grid input[type="radio"]:checked'); return c ? c.value : (this.variants[0] && this.variants[0].flavour); }
        get variant() {
          var f = this.flavour, s = this.servings;
          return this.variants.find(function (v) { return v.flavour === f && v.servings === s; })
            || this.variants.find(function (v) { return v.flavour === f; })
            || this.variants[0];
        }
        get plan() {
          var v = this.variant, select = this.querySelector('[data-rp-plan]');
          if (!v || !v.plans.length) return null;
          return v.plans.find(function (p) { return select && String(p.id) === select.value; }) || v.plans[0];
        }
        /* Eases the plan card's height (the accordions' 400ms curve, assets/rplnsh.js) so the price and
           Add to cart do not jump. Above the viewport (a change from the sticky bar) scrollBy holds the
           view instead; render() turns scroll anchoring off for that change so the two never both apply.
           Below the viewport, or with reduced motion, it snaps. */
        easeBox(box, from) {
          var to = box.getBoundingClientRect().height;
          if (Math.abs(to - from) < 1) return;
          var r = box.getBoundingClientRect();
          if (r.bottom <= 0) { window.scrollBy(0, to - from); return; }
          if (r.top >= window.innerHeight || !box.animate || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
          box.style.overflow = 'clip';
          var self = this, anim = this.boxAnim = box.animate([{ height: from + 'px' }, { height: to + 'px' }], { duration: 400, easing: 'cubic-bezier(0.2, 0.7, 0.2, 1)' });
          anim.onfinish = anim.oncancel = function () { box.style.overflow = ''; if (self.boxAnim === anim) self.boxAnim = null; };
        }
        render(initial) {
          var v = this.variant; if (!v) return;
          var plan = this.plan, subscribing = this.wantsSubscription && !!plan;
          var subInput = this.querySelector('input[name="purchase_option"][value="subscription"]');
          var onceInput = this.querySelector('input[name="purchase_option"][value="onetime"]');
          if (subInput) { subInput.disabled = !this.planned; subInput.checked = subscribing; }
          if (onceInput) onceInput.checked = !subscribing;
          this.querySelectorAll('.subscription-widget__toggle-option').forEach(function (label) {
            label.classList.toggle('subscription-widget__toggle-option--active', label.querySelector('input').checked);
          });
          /* on a size with no plan the toggle still shows what subscribing saves on the size that has one */
          var planned = plan ? null : this.planned;
          var saving = plan ? 'Save ' + money(v.price - plan.price) : (planned ? 'Save ' + money(planned.price - planned.plans[0].price) : '');
          this.querySelectorAll('[data-rp-save]').forEach(function (el) { el.textContent = saving; });
          this.querySelectorAll('[data-rp-compare]').forEach(function (el) { el.textContent = plan ? money(v.price) : ''; });
          this.querySelectorAll('[data-rp-sub-price]').forEach(function (el) { el.textContent = money(plan ? plan.price : v.price); });
          this.querySelectorAll('[data-rp-price]').forEach(function (el) { el.textContent = money(v.price); });
          /* the one-time panel's one call to action: subscribe on this variant, or on the size that has a plan */
          var instead = this.querySelector('[data-rp-subscribe-instead]');
          if (instead) {
            var target = plan ? v : planned, targetPlan = plan || (planned && planned.plans[0]);
            if (targetPlan) instead.textContent = instead.getAttribute('data-label-sub').replace('[saving]', money(target.price - targetPlan.price));
            instead.hidden = !targetPlan;
            /* the saving is against the size that has the plan, so name that size when it is not this one */
            var note = this.querySelector('[data-rp-switch-note]');
            if (note) note.textContent = !plan && planned ? instead.getAttribute('data-label-switch').replace('[servings]', planned.servings) + ' ' : '';
          }
          /* the savings lines above Add to cart: two lines in every state, so the button never moves */
          var line1 = this.section.querySelector('[data-rp-savings-1]'), line2 = this.section.querySelector('[data-rp-savings-2]');
          if (line1 && line2 && v.serves) {
            var serve = function (cents) { return money(Math.round(cents / v.serves)); };
            var lab = (this.section.querySelector('[data-rp-savings]') || {}).dataset || {};
            if (subscribing) {
              line1.textContent = money(plan.price) + ' ' + (lab.lDelivery || 'a delivery instead of') + ' ' + money(v.price);
              line2.textContent = serve(plan.price) + ' ' + (lab.lServeVs || 'a serve instead of') + ' ' + serve(v.price);
            } else {
              line1.textContent = money(v.price) + ' ' + (lab.lFor || 'for') + ' ' + v.servings;
              line2.textContent = serve(v.price) + ' ' + (lab.lServe || 'a serve');
            }
          }
          var servings = this.servings;
          this.querySelectorAll('.subscription-widget__tier-tab').forEach(function (tab) {
            var on = tab.getAttribute('data-servings') === servings;
            tab.classList.toggle('subscription-widget__tier-tab--active', on);
            tab.setAttribute('aria-pressed', on ? 'true' : 'false');
          });
          this.querySelectorAll('.subscription-widget__flavour-card').forEach(function (card) {
            card.classList.toggle('subscription-widget__flavour-card--selected', card.querySelector('input').checked);
          });
          /* both panels share one grid cell; the card takes the chosen one's height, eased by easeBox */
          var box = this.querySelector('.subscription-widget__step--panels');
          var from = box ? box.getBoundingClientRect().height : 0;
          if (this.boxAnim) { this.boxAnim.cancel(); this.boxAnim = null; }
          /* the browser's own scroll anchoring is off for this one change; easeBox holds the view itself */
          var root = document.documentElement;
          if (box && !initial) { root.style.overflowAnchor = 'none'; requestAnimationFrame(function () { root.style.overflowAnchor = ''; }); }
          this.querySelectorAll('.subscription-widget__panel').forEach(function (panel) {
            var on = (panel.getAttribute('data-panel') === 'subscription') === subscribing;
            panel.toggleAttribute('data-off', !on);
            panel.setAttribute('aria-hidden', on ? 'false' : 'true');
            panel.inert = !on;
          });
          if (box && !initial) this.easeBox(box, from);
          this.section.querySelectorAll('[data-rp-variant-id]').forEach(function (input) { input.value = v.id; });
          this.section.querySelectorAll('[data-rp-servings]').forEach(function (el) { el.textContent = v.servings; });
          this.sellingPlan = subscribing ? plan.id : null;
          var sp = this.sellingPlan;
          this.section.querySelectorAll('[data-rp-selling-plan]').forEach(function (input) { input.value = sp || ''; input.disabled = !sp; });
          if (!initial) {
            try { var url = new URL(window.location.href); url.searchParams.set('variant', v.id); history.replaceState(null, '', url); } catch (err) { /* file or sandboxed url */ }
          }
          if (this.form) this.form.dispatchEvent(new CustomEvent('variant:change', { bubbles: true, detail: { variant: v, sellingPlan: this.sellingPlan, initial: !!initial } }));
        }
      });
    }

    /* <rp-sticky-atc>: shows once the main Add to cart has scrolled above the
       viewport, never over an open dialog or the menu, and holds still under
       the cart drawer. Mirrors the widget both ways and adds through the same
       product form, source 'sticky'. */
    if (!customElements.get('rp-sticky-atc')) {
      customElements.define('rp-sticky-atc', class extends HTMLElement {
        connectedCallback() {
          this.section = this.closest('.shopify-section');
          this.form = document.forms[this.getAttribute('data-form')];
          this.widget = this.section && this.section.querySelector('subscription-widget-v2');
          var main = this.form && this.form.querySelector('[type="submit"]');
          if (!this.form || !main) return;
          var self = this;
          this.flavour = this.querySelector('[data-sticky-flavour]');
          this.plan = this.querySelector('[data-sticky-plan]');
          this.add = this.querySelector('[data-sticky-add]');
          /* a scroll check rather than an IntersectionObserver: a jump from
             below the button to above it crosses no threshold */
          var ticking = false;
          this.check = function () { ticking = false; self.past = main.getBoundingClientRect().bottom < 0; self.toggle(); };
          window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(self.check); } }, { passive: true });
          /* a dialog or the menu opening hides the bar */
          var queued = false;
          new MutationObserver(function () { if (!queued) { queued = true; requestAnimationFrame(function () { queued = false; self.toggle(); }); } })
            .observe(document.documentElement, { attributes: true, attributeFilter: ['open', 'class'], subtree: true });
          this.check();
          this.addEventListener('change', function () { self.faces(); });
          if (this.flavour) this.flavour.addEventListener('change', function () {
            var w = self.widget; if (!w) return;
            w.querySelectorAll('.subscription-widget__flavour-grid input[type="radio"]').forEach(function (r) { r.checked = r.value === self.flavour.value; });
            w.render();
          });
          if (this.plan) this.plan.addEventListener('change', function () {
            var w = self.widget; if (!w) return;
            var parts = self.plan.value.split('|');
            w.servings = parts[0]; w.wantsSubscription = parts[1] === 'sub';
            w.render();
          });
          this.add.addEventListener('click', function () {
            var pf = self.form.closest('rp-product-form');
            if (pf && pf.add) pf.add('sticky', self.add);
          });
          this.form.addEventListener('variant:change', function () { self.sync(); });
          new ResizeObserver(function () { document.documentElement.style.setProperty('--rp-sticky-h', self.offsetHeight + 'px'); }).observe(this);
          this.sync();
        }
        /* dialogs and the menu hide the bar; the cart drawer covers it where it stands */
        blocked() {
          var html = document.documentElement;
          return html.classList.contains('rp-menu-lock') || html.classList.contains('rp-zoom-lock') || !!document.querySelector('dialog[open]');
        }
        sync() {
          var w = this.widget; if (!w || !w.variant) return;
          var v = w.variant, plan = w.sellingPlan ? w.plan : null;
          if (this.flavour) this.flavour.value = v.flavour;
          if (this.plan) this.plan.value = v.servings + '|' + (plan ? 'sub' : 'once');
          var price = this.querySelector('[data-sticky-price]'); if (price) price.textContent = money(plan ? plan.price : v.price);
          var img = this.querySelector('[data-sticky-img]'); if (img && v.image) img.src = v.image;
          var meta = this.querySelector('[data-sticky-meta]');
          if (meta) meta.textContent = [v.flavour, v.servings, plan ? plan.name.replace(/\s*\(.*\)$/, '').toLowerCase() : null].filter(function (x) { return x && x !== 'Default Title'; }).join(', ');
          this.faces();
        }
        /* each select's face shows its chosen option's text */
        faces() {
          this.querySelectorAll('[data-sticky-face]').forEach(function (face) {
            var sel = face.previousElementSibling;
            if (sel && sel.tagName === 'SELECT' && sel.selectedIndex > -1) face.textContent = sel.options[sel.selectedIndex].text;
          });
        }
        toggle() {
          /* the page keeps its bottom padding while past the button, so a dialog opening never shifts it */
          document.documentElement.classList.toggle('rp-sticky-on', !!this.past);
          var show = !!this.past && !this.blocked();
          if (show === this.shown) return;
          this.shown = show;
          this.classList.toggle('rp-is-visible', show);
          this.inert = !show;
          this.setAttribute('aria-hidden', show ? 'false' : 'true');
        }
      });
    }

    /* <rp-product-form>: POST /cart/add.js, GET /cart.js, then cart:changed with
       the source and the added lines. The drawer is the one confirmation. */
    if (!customElements.get('rp-product-form')) {
      customElements.define('rp-product-form', class extends HTMLElement {
        connectedCallback() {
          var form = this.querySelector('form'); if (!form) return;
          this.form = form;
          var self = this;
          form.addEventListener('submit', function (e) { e.preventDefault(); self.add('product', form.querySelector('[type="submit"]')); });
        }
        get widget() { return this.closest('.shopify-section').querySelector('subscription-widget-v2'); }
        say(text) {
          var el = this.querySelector('.subscription-widget__qty-status'); if (!el) return;
          el.textContent = text;
        }
        add(source, button) {
          if (this.busy) return;
          var form = this.form, widget = this.widget;
          var id = Number(form.querySelector('[name="id"]').value);
          var item = { id: id, quantity: 1 };
          if (widget && widget.sellingPlan) item.selling_plan = widget.sellingPlan;
          var self = this;
          this.busy = true;
          this.say('');
          setAtc(button, 'adding');
          fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: JSON.stringify({ items: [item] }) })
            .then(function (r) { return r.json().catch(function () { return {}; }).then(function (body) { if (!r.ok) throw new Error(body.description || body.message || 'That did not reach the cart. Please try again.'); return body; }); })
            .then(function (added) {
              return fetch(root + 'cart.js', { headers: { 'Accept': 'application/json' } })
                .then(function (r) { if (!r.ok) throw new Error('The cart did not answer. Please try again.'); return r.json(); })
                .then(function (cart) {
                  var detail = Object.assign({}, cart, { source: source, added: addedLines(added, cart, item) });
                  document.dispatchEvent(new CustomEvent('cart:changed', { detail: detail }));
                  setAtc(button, 'added');
                  clearTimeout(self.timer);
                  self.timer = setTimeout(function () { setAtc(button, 'idle'); }, 1600);
                });
            })
            .catch(function (err) { setAtc(button, 'idle'); self.say(err.message); })
            .finally(function () { self.busy = false; });
        }
      });
    }

    };

    /* after parse: define the elements, then wire Read more (plain DOM) */
    var ready = function () {
      defineElements();
      document.querySelectorAll('.section-rp-main-product [data-rp-desc]').forEach(function (box) {
        var body = box.querySelector('.rp-mp__desc-body'), more = box.querySelector('.rp-mp__desc-more');
        if (!body || !more || box.dataset.ready) return;
        box.dataset.ready = '1';
        more.addEventListener('click', function () {
          var open = more.getAttribute('aria-expanded') !== 'true';
          more.setAttribute('aria-expanded', String(open));
          body.classList.toggle('is-clamped', !open);
          more.textContent = open ? more.getAttribute('data-less') : more.getAttribute('data-more');
        });
      });
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ready); else ready();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rp-menu-drawer"] && !Shopify.designMode) return;
  try {
    
  /* The header supplies only the toggle button; this section owns the overlay. */
  (function () {
    var FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

    function wire() {
      var menu = document.getElementById('rp-menu');
      if (!menu) return;
      var toggle = document.querySelector('.mh__icon--menu');
      var close = menu.querySelector('.rp-menu__close');
      var cta = menu.querySelector('.rp-menu__cta');
      var opener = null;

      if (toggle) {
        toggle.setAttribute('aria-controls', 'rp-menu');
        toggle.setAttribute('aria-expanded', 'false');
      }

      function isOpen() { return menu.classList.contains('rp-is-open'); }

      /* frost the cart bar only when the panel actually scrolls under it */
      var panel = menu.querySelector('.rp-menu__panel');
      function syncScrolls() { if (panel) menu.classList.toggle('rp-menu--scrolls', panel.scrollHeight > panel.clientHeight + 1); }
      window.addEventListener('resize', syncScrolls, { passive: true });

      function focusable() {
        return Array.prototype.filter.call(menu.querySelectorAll(FOCUSABLE), function (el) {
          return el.getClientRects().length > 0;
        });
      }

      /* moveFocus is false only for the on-load open, so focus stays put */
      function open(moveFocus) {
        if (isOpen()) return;
        opener = document.activeElement;
        menu.classList.add('rp-is-open');
        syncScrolls();
        menu.setAttribute('aria-hidden', 'false');
        if (toggle) toggle.setAttribute('aria-expanded', 'true');
        document.documentElement.classList.add('rp-menu-lock');
        document.addEventListener('keydown', onKeydown);
        if (moveFocus !== false) {
          close.focus();
          if (document.activeElement !== close) requestAnimationFrame(function () { close.focus(); });
        }
        menu.dispatchEvent(new CustomEvent('rp:menu-opened', { bubbles: true }));
      }

      function shut(returnFocus) {
        if (!isOpen()) return;
        menu.classList.remove('rp-is-open');
        menu.setAttribute('aria-hidden', 'true');
        if (toggle) toggle.setAttribute('aria-expanded', 'false');
        document.documentElement.classList.remove('rp-menu-lock');
        document.removeEventListener('keydown', onKeydown);
        var target = toggle || opener;
        if (returnFocus !== false && target && typeof target.focus === 'function') target.focus();
        menu.dispatchEvent(new CustomEvent('rp:menu-closed', { bubbles: true }));
      }

      function onKeydown(e) {
        if (e.key === 'Escape') { e.preventDefault(); shut(); return; }
        if (e.key !== 'Tab') return;
        var list = focusable();
        if (!list.length) return;
        var first = list[0];
        var last = list[list.length - 1];
        var inside = menu.contains(document.activeElement);
        if (e.shiftKey) {
          if (!inside || document.activeElement === first) { e.preventDefault(); last.focus(); }
        } else if (!inside || document.activeElement === last) {
          e.preventDefault(); first.focus();
        }
      }

      if (toggle) toggle.addEventListener('click', function (e) { e.preventDefault(); open(true); });
      close.addEventListener('click', function () { shut(); });
      var scrim = menu.querySelector('[data-menu-close]');
      if (scrim) scrim.addEventListener('click', function () { shut(); });

      /* Cart: hand over to the cart drawer when one is on the page (it can
         also claim the event by cancelling it); otherwise the link goes to
         the cart page as it would without script. */
      if (cta) cta.addEventListener('click', function (e) {
        var ev = new CustomEvent('rp:open-cart', { bubbles: true, cancelable: true, detail: { source: 'rp-menu' } });
        document.dispatchEvent(ev);
        if (ev.defaultPrevented || document.querySelector('rp-cart-drawer')) {
          e.preventDefault();
          shut(false);
        }
      });

      document.addEventListener('rp:open-menu', function () { open(true); });
      document.addEventListener('rp:close-menu', function () { shut(); });

      if (document.body.classList.contains('rp-open-menu')) open(false);
    }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', wire);
    else wire();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rp-policy"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const slugify = (s) => s.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '') || 'section';

    /* a heading is a real <h2-4>, a <p> in capitals, or a top-level <ol> whose
       one <li> holds no nested list (numbered section markers) */
    const findHeadings = (body) => {
      const out = [];
      for (const child of [...body.children]) {
        const tag = child.tagName;
        if (tag === 'H2' || tag === 'H3' || tag === 'H4') {
          const text = child.textContent.trim();
          if (text) out.push({ el: child, text });
        } else if (tag === 'P') {
          const text = child.textContent.trim();
          if (text && text.length <= 90 && /[A-Z]/.test(text) && !/[a-z]/.test(text)) out.push({ el: child, text });
        } else if (tag === 'OL') {
          const items = child.children;
          if (items.length === 1 && items[0].tagName === 'LI' && !items[0].querySelector('ol, ul')) {
            const text = items[0].textContent.trim();
            if (text) out.push({ el: child, text });
          }
        }
      }
      return out;
    };

    const init = (root) => {
      const body = root.querySelector('[data-pol-body]');
      const details = root.querySelector('[data-pol-index]');
      const list = root.querySelector('[data-pol-index-list]');
      if (!body || !details || !list) return;
      const headings = findHeadings(body);
      if (!headings.length) return;

      const used = new Set();
      for (const h of headings) {
        const base = 'pol-' + slugify(h.text);
        let id = base, n = 2;
        while (used.has(id)) { id = `${base}-${n}`; n += 1; }
        used.add(id);
        h.el.id = id;
        h.el.classList.add('rp-pol__heading');
        h.el.style.scrollMarginTop = '7rem';
        const li = document.createElement('li');
        const a = document.createElement('a');
        a.href = '#' + id;
        a.className = 'rp-pol__index-link rp-link-faded';
        a.textContent = h.text;
        li.appendChild(a);
        list.appendChild(li);
      }
      details.hidden = false;

      const wide = window.matchMedia('(min-width: 1000px)');
      /* wide: the index is always open and its summary is a plain label, out of the tab order */
      const sync = () => { details.open = wide.matches; details.querySelector('summary').tabIndex = wide.matches ? -1 : 0; };
      sync();
      wide.addEventListener('change', sync);
      details.querySelector('summary').addEventListener('click', (e) => { if (wide.matches) e.preventDefault(); });
    };

    const start = () => { for (const root of document.querySelectorAll('.section-rp-policy')) { if (root.dataset.rpPol) continue; root.dataset.rpPol = '1'; init(root); } };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
    else start();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rp-reviews-carousel"] && !Shopify.designMode) return;
  try {
    
  (() => {
    /* build the cards from Stamped: the design's card markup, one per review that has text */
    const fill = async (section) => {
      const track = section.querySelector('.rp-rc__track');
      const tpl = section.querySelector('template[data-rc-card]');
      if (!track || !tpl || track.children.length) return;
      if (!window.RP?.reviews) await new Promise((r) => document.addEventListener('rp:reviews-ready', r, { once: true }));
      const d = track.dataset;
      const { reviews } = await RP.reviews.list({ apiKey: d.stampedKey, storeUrl: d.stampedStore, productId: d.productId });
      let shown = 0;
      for (const review of reviews) {
        if (!review.message) continue;
        if (shown >= Number(d.count || 12)) break;
        shown += 1;
        const li = tpl.content.firstElementChild.cloneNode(true);
        li.classList.add(`rp-rc__slide--${shown % 4}`);
        if (review.message.length > 170) li.classList.add('is-long');
        li.querySelector('.rp-rc__card').dataset.reviewId = review.id;
        const stars = li.querySelector('.rp-rc__stars');
        stars.setAttribute('aria-label', `Rated ${review.rating} out of 5`);
        stars.querySelectorAll('svg').forEach((svg, i) => { if (i + 1 > review.rating) svg.classList.add('is-off'); });
        const title = li.querySelector('.rp-rc__title');
        if (review.title) title.textContent = review.title; else title.remove();
        const bodyId = `rp-rc-body-${d.sectionId}-${review.id}`;
        li.querySelector('.rp-rc__body').id = bodyId;
        li.querySelector('.rp-rc__more').setAttribute('aria-controls', bodyId);
        RP.reviews.text(li.querySelector('.rp-rc__text'), review.message);
        li.querySelector('.rp-rc__author').textContent = review.author;
        li.querySelector('.rp-rc__product').textContent = review.product || d.productTitle;
        track.append(li);
      }
    };
    const init = (root) => {
      for (const section of root.querySelectorAll('.rp-rc')) {
        if (section.dataset.ready) continue;
        section.dataset.ready = '1';
        fill(section).catch(() => {}).finally(() => setup(section));
      }
    };
    const setup = (section) => {
      {
        const track = section.querySelector('.rp-rc__track');
        const prev = section.querySelector('[data-rc-prev]');
        const next = section.querySelector('[data-rc-next]');
        if (!track) return;
        const reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
        const step = () => {
          const slide = track.querySelector('.rp-rc__slide');
          return slide ? slide.getBoundingClientRect().width + parseFloat(getComputedStyle(track).columnGap || '0') : track.clientWidth;
        };
        /* one card per press, wrapping at either end */
        const go = (dir) => {
          const behavior = reduce.matches ? 'auto' : 'smooth';
          const max = track.scrollWidth - track.clientWidth;
          if (dir > 0 && track.scrollLeft >= max - 2) track.scrollTo({ left: 0, behavior });
          else if (dir < 0 && track.scrollLeft <= 2) track.scrollTo({ left: max, behavior });
          else track.scrollBy({ left: dir * step(), behavior });
        };
        prev?.addEventListener('click', () => go(-1));
        next?.addEventListener('click', () => go(1));

        /* Read more only where the text is actually clamped */
        const sync = () => {
          for (const card of section.querySelectorAll('.rp-rc__card')) {
            const text = card.querySelector('.rp-rc__text');
            const more = card.querySelector('.rp-rc__more');
            if (!text || !more || card.classList.contains('is-expanded')) continue;
            more.hidden = text.scrollHeight <= text.clientHeight + 1;
          }
        };
        section.addEventListener('click', (event) => {
          const more = event.target.closest('.rp-rc__more');
          if (!more) return;
          const card = more.closest('.rp-rc__card');
          const open = !card.classList.contains('is-expanded');
          card.classList.toggle('is-expanded', open);
          more.setAttribute('aria-expanded', String(open));
          more.textContent = open ? (more.dataset.less || 'Show less') : (more.dataset.more || 'Read more');
        });
        sync();
        new ResizeObserver(sync).observe(track);

        /* touch: a tap lights a card, a second tap or a tap anywhere else clears it. A swipe never lights
           one (a moved track is ignored). No preventDefault, so links and buttons in a card still work */
        let pointer = 'mouse';
        let startLeft = 0;
        const clear = () => { for (const c of track.querySelectorAll('.rp-rc__card.is-lit')) c.classList.remove('is-lit'); };
        track.addEventListener('pointerdown', (event) => { pointer = event.pointerType; startLeft = track.scrollLeft; }, { passive: true });
        track.addEventListener('click', (event) => {
          if (pointer === 'mouse' || Math.abs(track.scrollLeft - startLeft) > 2) return;
          if (event.target.closest('a, button')) return;
          const card = event.target.closest('.rp-rc__card');
          const lit = card?.classList.contains('is-lit');
          clear();
          if (card && !lit) card.classList.add('is-lit');
        });
        document.addEventListener('click', (event) => { if (!track.contains(event.target)) clear(); });
      }
    };
    const boot = () => init(document);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
    else boot();
    document.addEventListener('shopify:section:load', (e) => init(e.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rp-reviews-widget"] && !Shopify.designMode) return;
  try {
    
  (() => {
    /* build the list from Stamped: the design's card markup, page_size shown, the rest behind Show more */
    const fill = async (widget) => {
      const list = widget.querySelector('.rp-rw__list');
      const tpl = widget.querySelector('template[data-rw-card]');
      if (!list || !tpl || list.dataset.filled) return;
      list.dataset.filled = '1';
      if (!window.RP?.reviews) await new Promise((r) => document.addEventListener('rp:reviews-ready', r, { once: true }));
      const d = list.dataset;
      const size = Number(d.pageSize) || 6;
      const { reviews } = await RP.reviews.list({ apiKey: d.stampedKey, storeUrl: d.stampedStore, productId: d.productId });
      let shown = 0;
      for (const review of reviews) {
        if (!review.message && !review.title) continue;
        shown += 1;
        const li = tpl.content.firstElementChild.cloneNode(true);
        if (shown > size) li.hidden = true;
        li.querySelector('.rp-rw__card').dataset.reviewId = review.id;
        const stars = li.querySelector('.rp-rw__stars');
        stars.setAttribute('aria-label', `Rated ${review.rating} out of 5`);
        stars.querySelectorAll('svg').forEach((svg, i) => { if (i + 1 > review.rating) svg.classList.add('is-off'); });
        li.querySelector('.rp-rw__author').textContent = review.author;
        const title = li.querySelector('.rp-rw__title');
        if (review.title) title.textContent = review.title; else title.remove();
        const text = li.querySelector('.rp-rw__text');
        if (review.message) RP.reviews.text(text, review.message); else text.remove();
        li.querySelector('.rp-rw__product').textContent = review.product || d.productTitle;
        list.append(li);
      }
      const row = widget.querySelector('.rp-rw__more-row');
      if (row && shown > size) {
        row.hidden = false;
        const out = row.querySelector('[data-rw-shown]');
        if (out) out.textContent = `${size} of ${shown} shown`;
      }
    };
    const init = (root) => {
      for (const widget of root.querySelectorAll('.rp-rw')) {
        if (widget.dataset.ready) continue;
        widget.dataset.ready = '1';
        fill(widget).catch(() => {}).finally(() => setup(widget));
      }
    };
    const setup = (widget) => {
      {
        /* touch: a tap lights a review, a second tap or a tap anywhere else clears it. A scroll never lights
           one (the browser cancels the pointer when it pans). No preventDefault, so links still work */
        const cards = widget.querySelector('.rp-rw__list');
        if (cards && !cards.dataset.tapReady) {
          cards.dataset.tapReady = '1';
          let pointer = 'mouse';
          const clear = () => { for (const c of cards.querySelectorAll('.rp-rw__card.is-lit')) c.classList.remove('is-lit'); };
          cards.addEventListener('pointerdown', (event) => { pointer = event.pointerType; }, { passive: true });
          cards.addEventListener('click', (event) => {
            if (pointer === 'mouse' || event.target.closest('a, button')) return;
            const card = event.target.closest('.rp-rw__card');
            const lit = card?.classList.contains('is-lit');
            clear();
            if (card && !lit) card.classList.add('is-lit');
          });
          document.addEventListener('click', (event) => { if (!cards.contains(event.target)) clear(); });
        }

        const more = widget.querySelector('[data-rw-more]');
        if (!more || more.dataset.ready) return;
        more.dataset.ready = '1';
        const list = widget.querySelector('.rp-rw__list');
        const size = Number(list.dataset.pageSize) || 6;
        const out = widget.querySelector('[data-rw-shown]');
        more.addEventListener('click', () => {
          const hidden = [...list.querySelectorAll('.rp-rw__item[hidden]')];
          const next = hidden.slice(0, size);
          for (const item of next) item.hidden = false;
          const total = list.children.length;
          const visible = total - hidden.length + next.length;
          if (out) out.textContent = `${visible} of ${total} shown`;
          next[0]?.querySelector('article')?.setAttribute('tabindex', '-1');
          next[0]?.querySelector('article')?.focus({ preventScroll: true });
          if (visible >= total) more.hidden = true;
        });
      }
    };
    const boot = () => init(document);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
    else boot();
    document.addEventListener('shopify:section:load', (e) => init(e.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rp-scratch-popup"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('rp-scratch-popup')) {
    customElements.define('rp-scratch-popup', class extends HTMLElement {
      connectedCallback() {
        if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', () => this.connectedCallback(), { once: true }); return; }
        if (this.ready) return;
        this.ready = true;
        const $ = (s) => this.querySelector(s);
        this.dialog = $('dialog');
        this.card = $('[data-sw-card]');
        this.under = $('[data-sw-under]');
        this.cover = $('[data-sw-cover]');
        this.ctx = this.cover.getContext('2d', { willReadFrequently: true });
        this.dust = $('[data-sw-dust]');
        this.dctx = this.dust.getContext('2d');
        this.live = $('[data-sw-live]');
        this.form = $('form');
        this.threshold = Number(this.dataset.threshold || 50) / 100;
        this.giveUp = Number(this.dataset.giveUp || 3) * 1000;
        this.reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.flecks = [];
        /* no crossOrigin: coverage never reads pixels back, so a CDN image
           from another origin can be drawn as is */
        const load = (src) => { const i = new Image(); i.decoding = 'async'; i.src = src; i.addEventListener('load', () => { if (this.dialog.open && !this.started) this.paint(); }); return i; };
        /* the cover photo, mark and background load ahead of the first open: when a 10% control is touched,
           hovered or focused, and quietly once the page has finished loading. Never with the page itself. */
        this.loadImg = load;
        const warm = () => this.warm();
        for (const t of ['pointerover', 'touchstart', 'focusin']) document.addEventListener(t, (e) => { if (e.target.closest?.('[data-rp-offer-open]')) warm(); }, { passive: true });
        const idle = () => (window.requestIdleCallback ? requestIdleCallback(warm, { timeout: 5000 }) : setTimeout(warm, 3000));
        if (document.readyState === 'complete') idle(); else window.addEventListener('load', idle, { once: true });

        for (const b of this.querySelectorAll('[data-sw-close]')) b.addEventListener('click', () => this.close());
        this.dialog.addEventListener('cancel', (e) => { e.preventDefault(); this.close(); });
        $('[data-sw-reveal]').addEventListener('click', () => this.reveal('button'));
        $('[data-sw-claim]').addEventListener('click', () => { this.stage('claim'); $('input[type="email"]').focus({ preventScroll: true }); });
        this.form?.addEventListener('submit', (e) => this.submit(e));
        $('[data-sw-copy]')?.addEventListener('click', () => this.copy());
        this.cover.addEventListener('pointerdown', (e) => this.down(e));
        this.cover.addEventListener('pointermove', (e) => this.move(e));
        for (const t of ['pointerup', 'pointercancel', 'lostpointercapture']) this.cover.addEventListener(t, () => this.up());
        new ResizeObserver(() => { if (this.dialog.open && !this.started) this.paint(); }).observe(this.card);

        /* every "10% off" control in the theme lands here, and wins over the sample pop-up */
        document.addEventListener('click', (e) => {
          const trigger = e.target.closest?.('[data-rp-offer-open]');
          if (!trigger) return;
          e.preventDefault();
          document.querySelector('rp-sample-popup')?.close?.();
          this.open();
        });

        this.stage('play');
        if (['scratch', 'offer'].includes(new URLSearchParams(location.search).get('popup'))) this.open();
      }

      /* one attribute names the stage; each slot shows the states listed for
         it, the rest are hidden and inert, and under the cover all is inert */
      stage(name) {
        this.dataset.stage = name;
        for (const el of this.querySelectorAll('[data-sw-in]')) {
          const on = el.dataset.swIn.split(' ').includes(name);
          el.toggleAttribute('data-off', !on);
          el.inert = !on;
        }
        this.under.inert = name === 'play';
      }

      open() {
        if (this.dialog.open) return;
        this.opener = document.activeElement;
        this.started = this.revealed = false;
        this.strokes = 0;
        this.flecks.length = 0;
        this.classList.remove('is-revealed');
        this.cover.hidden = false;
        this.live.textContent = '';
        this.stage('play');
        this.warm();
        this.dialog.showModal();
        this.querySelector('[data-sw-title]').focus({ preventScroll: true });
        requestAnimationFrame(() => { this.paint(); setTimeout(() => { if (this.w) this.stamps(this.brush()); }, 50); });
        document.fonts?.load('800 40px Chivo').then(() => { if (!this.started) this.paint(); });
      }

      warm() {
        if (this.photo) return;
        this.photo = this.loadImg(this.dataset.photo);
        this.markImg = this.loadImg(this.dataset.mark);
        if (this.dataset.sky) this.loadImg(this.dataset.sky);
      }

      close() {
        clearTimeout(this.idle);
        if (!this.dialog.open) return;
        this.dialog.close();
        if (this.opener && this.opener !== document.body && document.contains(this.opener) && typeof this.opener.focus === 'function') this.opener.focus();
        this.opener = null;
      }

      /* the cover: the photograph filling the card, a soft fall to dark at
         the foot, a light gloss, and the cover heading in lime */
      paint() {
        const r = this.card.getBoundingClientRect();
        if (!r.width) return;
        this.sample = undefined;
        const dpr = Math.min(window.devicePixelRatio || 1, 2);
        const w = (this.w = r.width), h = (this.h = r.height);
        for (const cv of [this.cover, this.dust]) { cv.width = Math.round(w * dpr); cv.height = Math.round(h * dpr); }
        this.dctx.setTransform(dpr, 0, 0, dpr, 0, 0);
        const c = this.ctx;
        c.setTransform(dpr, 0, 0, dpr, 0, 0);
        c.globalCompositeOperation = 'source-over';
        c.fillStyle = '#16181b';
        c.fillRect(0, 0, w, h);

        /* a tall card (phone) runs the photograph full height with the type
           over a fall to dark at the foot; a wide card (desktop) keeps the
           photograph to the left at its own portrait crop, beside a black
           block with the type. Same split as the layout under. */
        const wide = w > h * 1.1;
        const split = wide ? w * (1.25 / 2.25) : w;
        const img = this.photo;
        if (img && img.complete && img.naturalWidth) {
          const s = Math.max(split / img.naturalWidth, h / img.naturalHeight);
          const dw = img.naturalWidth * s, dh = img.naturalHeight * s;
          c.save();
          c.beginPath(); c.rect(0, 0, split, h); c.clip();
          c.drawImage(img, (split - dw) * 0.5, (h - dh) * 0.18, dw, dh);
          c.restore();
        }

        if (wide) {
          /* desktop: a solid black block on the right, beside the photograph */
          c.fillStyle = '#000';
          c.fillRect(split, 0, w - split, h);
        } else {
          /* phone: a fall to dark at the foot, under the type */
          const fall = c.createLinearGradient(0, h * 0.34, 0, h);
          fall.addColorStop(0, 'rgb(22 24 27 / 0)');
          fall.addColorStop(0.45, 'rgb(22 24 27 / 0.5)');
          fall.addColorStop(1, 'rgb(22 24 27 / 0.88)');
          c.fillStyle = fall;
          c.fillRect(0, 0, w, h);
        }

        const gloss = c.createLinearGradient(0, 0, w, h);
        gloss.addColorStop(0, 'rgb(255 255 255 / 0.1)');
        gloss.addColorStop(0.35, 'rgb(255 255 255 / 0)');
        gloss.addColorStop(0.62, 'rgb(255 255 255 / 0.06)');
        gloss.addColorStop(1, 'rgb(255 255 255 / 0)');
        c.fillStyle = gloss;
        c.fillRect(0, 0, w, h);
        for (let i = 0, n = Math.round((w * h) / 22); i < n; i++) {
          c.fillStyle = `rgb(255 255 255 / ${(0.015 + Math.random() * 0.04).toFixed(3)})`;
          c.fillRect(Math.random() * w, Math.random() * h, 1, 1);
        }

        this.type(c, wide ? { x: split, w: w - split, h, center: true } : { x: 0, w, h, center: false });
        this.cols = Math.max(12, Math.round(w / 18));
        this.rows = Math.max(12, Math.round(h / 18));
        this.hits = new Uint8Array(this.cols * this.rows);
      }

      type(c, box) {
        const { w, h } = box;
        const words = (this.cover.dataset.heading || 'Scratch to win').toUpperCase().split(' ');
        let size = box.center ? Math.min(w * 0.21, 88) : Math.min(w * 0.19, h * 0.13, 96);
        const font = () => { c.font = `800 ${size}px Chivo, sans-serif`; };
        font();
        /* two lines, split where the longer line is shortest: never a word left alone */
        let lines = words;
        if (words.length > 2) {
          let best = Infinity;
          for (let i = 1; i < words.length; i++) {
            const pair = [words.slice(0, i).join(' '), words.slice(i).join(' ')];
            const widest = Math.max(...pair.map((l) => c.measureText(l).width));
            if (widest < best) { best = widest; lines = pair; }
          }
        }
        const widest = Math.max(...lines.map((l) => c.measureText(l).width));
        if (widest > w * 0.82) { size *= (w * 0.82) / widest; font(); }
        const lh = size * 0.92;
        const markW = Math.min(w * 0.26, 104), markH = markW * (560 / 2086);
        const cx = box.x + w / 2;
        const block = markH + 16 + lh * lines.length;
        let y = box.center ? (h - block) / 2 - 12 : h - 76 - block;

        if (this.markImg && this.markImg.complete && this.markImg.naturalWidth) {
          const m = document.createElement('canvas');
          m.width = Math.round(markW * 2); m.height = Math.round(markH * 2);
          const mc = m.getContext('2d');
          mc.drawImage(this.markImg, 0, 0, m.width, m.height);
          mc.globalCompositeOperation = 'source-in';
          mc.fillStyle = '#fff';
          mc.fillRect(0, 0, m.width, m.height);
          c.drawImage(m, cx - markW / 2, y, markW, markH);
        }
        y += markH + 16;

        /* flat lime type */
        c.textAlign = 'center';
        c.textBaseline = 'top';
        if ('letterSpacing' in c) c.letterSpacing = `${(-0.02 * size).toFixed(1)}px`;
        const top = y;
        c.fillStyle = '#a8ff45';
        lines.forEach((l, i) => c.fillText(l, cx, top + i * lh));
        if ('letterSpacing' in c) c.letterSpacing = '0px';
      }

      point(e) { const r = this.cover.getBoundingClientRect(); return { x: (e.clientX - r.left) * (this.w / r.width), y: (e.clientY - r.top) * (this.h / r.height) }; }
      brush() { return Math.max(40, Math.min(this.w, this.h) * 0.13); }

      down(e) {
        if (this.revealed) return;
        e.preventDefault();
        clearTimeout(this.idle);
        this.cover.setPointerCapture?.(e.pointerId);
        this.drawing = this.started = true;
        this.last = this.point(e);
        this.stroke(this.last, this.last);
      }

      move(e) {
        if (!this.drawing || this.revealed) return;
        const events = e.getCoalescedEvents ? e.getCoalescedEvents() : [];
        for (const ev of events.length ? events : [e]) { const p = this.point(ev); this.stroke(this.last, p); this.last = p; }
      }

      /* the cover lifts only when the finger comes up, never mid-stroke. Short
         of the mark, a pause of settings.give_up seconds lifts it anyway, so
         someone who gives up partway still sees the offer. */
      up() {
        if (!this.drawing) return;
        this.drawing = false;
        this.check();
        clearTimeout(this.idle);
        if (!this.revealed) this.idle = setTimeout(() => this.reveal('scratch'), this.giveUp);
      }

      /* a coin scratch: a few brush stamps made once, each a ragged solid
         core with a gritty rim and fine scrape lines, stamped along the
         path and turned to the stroke's direction */
      stamps(R) {
        if (this.stampR === R) return this.stampSet;
        const make = () => {
          const S = Math.ceil(R * 4), k = S / (R * 2), cv = document.createElement('canvas');
          cv.width = cv.height = S;
          const g = cv.getContext('2d'), m = S / 2;
          g.translate(m, m);
          g.fillStyle = '#000';
          const ph = [Math.random() * 6, Math.random() * 6, Math.random() * 6];
          g.beginPath();
          for (let t = 0; t <= Math.PI * 2 + 0.01; t += Math.PI / 60) {
            const n = 0.5 * Math.sin(t * 3 + ph[0]) + 0.3 * Math.sin(t * 7 + ph[1]) + 0.2 * Math.sin(t * 13 + ph[2]);
            const r = R * k * (0.8 + 0.08 * n + (Math.random() - 0.5) * 0.05);
            t === 0 ? g.moveTo(Math.cos(t) * r, Math.sin(t) * r) : g.lineTo(Math.cos(t) * r, Math.sin(t) * r);
          }
          g.fill();
          for (let i = 0; i < 260; i++) {
            const t = Math.random() * Math.PI * 2, r = R * k * (0.74 + Math.random() * 0.3);
            g.globalAlpha = 0.35 + Math.random() * 0.65;
            g.beginPath(); g.arc(Math.cos(t) * r, Math.sin(t) * r, (0.6 + Math.random() * 1.6) * k, 0, Math.PI * 2); g.fill();
          }
          g.lineCap = 'round';
          for (let i = 0; i < 14; i++) {
            const y = (Math.random() - 0.5) * R * k * 1.7, half = Math.sqrt(Math.max(0, (R * k) ** 2 - y * y)) * (0.9 + Math.random() * 0.2);
            g.globalAlpha = 0.25 + Math.random() * 0.4;
            g.lineWidth = (0.6 + Math.random()) * k;
            g.beginPath(); g.moveTo(-half, y); g.lineTo(half, y); g.stroke();
          }
          return cv;
        };
        this.stampR = R;
        this.stampSet = [make(), make(), make()];
        return this.stampSet;
      }

      stroke(a, b) {
        const c = this.ctx, R = this.brush(), set = this.stamps(R);
        const dist = Math.hypot(b.x - a.x, b.y - a.y), ang = Math.atan2(b.y - a.y, b.x - a.x);
        this.tone(b);
        const steps = Math.max(1, Math.ceil(dist / (R * 0.3)));
        c.globalCompositeOperation = 'destination-out';
        for (let i = 1; i <= steps; i++) {
          const x = a.x + ((b.x - a.x) * i) / steps, y = a.y + ((b.y - a.y) * i) / steps;
          c.save();
          c.translate(x, y);
          c.rotate(ang + (Math.random() - 0.5) * 0.3);
          c.drawImage(set[(Math.random() * set.length) | 0], -R, -R, R * 2, R * 2);
          c.restore();
        }
        c.globalCompositeOperation = 'source-over';
        this.track(a, b, R * 0.75);
        this.shed(b, dist);
      }

      /* the colour under the coin, so the flakes are made of what is being
         scratched. A cover drawn from another origin cannot be read back;
         then the flakes fall back to neutral tones. */
      tone(p) {
        /* one small colour sample of the cover, read once per paint: reading the full canvas back on every
           movement stalled the scratch on phones */
        if (this.sample === undefined) {
          try {
            const sw = 24, sh = 40, cv = document.createElement('canvas');
            cv.width = sw; cv.height = sh;
            const g = cv.getContext('2d', { willReadFrequently: true });
            g.drawImage(this.cover, 0, 0, sw, sh);
            this.sample = { d: g.getImageData(0, 0, sw, sh).data, sw, sh };
          } catch { this.sample = null; }
        }
        if (!this.sample) { this.fleckTone = null; return; }
        const { d, sw, sh } = this.sample;
        const x = Math.min(sw - 1, Math.max(0, Math.floor((p.x / this.w) * sw))), y = Math.min(sh - 1, Math.max(0, Math.floor((p.y / this.h) * sh)));
        const i = (y * sw + x) * 4;
        if (d[i + 3] > 40) this.fleckTone = `rgb(${d[i]} ${d[i + 1]} ${d[i + 2]})`;
      }

      /* coverage: grid cells the brush core passed over */
      track(a, b, rad) {
        if (!this.hits) return;
        const cw = this.w / this.cols, ch = this.h / this.rows;
        const steps = Math.max(1, Math.ceil(Math.hypot(b.x - a.x, b.y - a.y) / (rad / 2)));
        for (let i = 0; i <= steps; i++) {
          const x = a.x + ((b.x - a.x) * i) / steps, y = a.y + ((b.y - a.y) * i) / steps;
          const c0 = Math.max(0, Math.floor((x - rad) / cw)), c1 = Math.min(this.cols - 1, Math.floor((x + rad) / cw));
          const r0 = Math.max(0, Math.floor((y - rad) / ch)), r1 = Math.min(this.rows - 1, Math.floor((y + rad) / ch));
          for (let row = r0; row <= r1; row++) for (let col = c0; col <= c1; col++) {
            if (Math.hypot((col + 0.5) * cw - x, (row + 0.5) * ch - y) <= rad) this.hits[row * this.cols + col] = 1;
          }
        }
      }

      check() {
        if (this.revealed || !this.hits) return;
        let n = 0;
        for (const v of this.hits) n += v;
        if (n / this.hits.length >= this.threshold) this.reveal('scratch');
      }

      /* dust: a few flecks come off under the finger and fall; capped, and off under reduced motion */
      shed(p, dist) {
        if (this.reduce.matches) return;
        const tones = this.fleckTone ? [this.fleckTone, this.fleckTone, '#d9dde2', '#1b1d20'] : ['#1b1d20', '#d9dde2', '#5b6068', '#8d939c'];
        for (let i = 0, n = Math.min(4, 1 + Math.floor(dist / 10)); i < n && this.flecks.length < 180; i++) {
          this.flecks.push({ x: p.x + (Math.random() - 0.5) * 30, y: p.y + (Math.random() - 0.5) * 30, vx: (Math.random() - 0.5) * 110, vy: -40 - Math.random() * 80, s: 1.4 + Math.random() * 2.6, t: 0, life: 460 + Math.random() * 420, tone: tones[(Math.random() * tones.length) | 0] });
        }
        if (!this.raf) { this.prev = performance.now(); this.raf = requestAnimationFrame((t) => this.tick(t)); }
      }

      tick(now) {
        const dt = Math.min(40, now - this.prev) / 1000, c = this.dctx;
        this.prev = now;
        c.clearRect(0, 0, this.w, this.h);
        this.flecks = this.flecks.filter((f) => (f.t += dt * 1000) < f.life);
        for (const f of this.flecks) {
          f.vy += 900 * dt; f.x += f.vx * dt; f.y += f.vy * dt;
          c.globalAlpha = 1 - f.t / f.life;
          c.fillStyle = f.tone;
          c.fillRect(f.x, f.y, f.s, f.s);
        }
        c.globalAlpha = 1;
        this.raf = this.flecks.length ? requestAnimationFrame((t) => this.tick(t)) : 0;
      }

      reveal(via) {
        clearTimeout(this.idle);
        if (this.revealed || !this.dialog.open) return;
        this.revealed = true;
        this.drawing = false;
        this.classList.add('is-revealed');
        const q = (s) => this.querySelector(s).textContent.replace(/\s+/g, ' ').trim();
        this.live.textContent = `${q('[data-sw-offer]')}. ${q('[data-sw-cond]')}.`;
        this.stage('won');
        if (!this.reduce.matches) navigator.vibrate?.(12);
        if (this.reduce.matches) this.cover.hidden = true;
        else this.cover.addEventListener('transitionend', () => { this.cover.hidden = true; }, { once: true });
        /* keyboard reveal goes to Claim; a scratch parks focus on the offer, so no ring under a finger */
        this.querySelector(via === 'button' ? '[data-sw-claim]' : '[data-sw-offer]').focus({ preventScroll: true });
      }

      /* Klaviyo first (the list whose welcome flow sends the offer, as the live store's form does);
         if Klaviyo is not set up or cannot be reached (an ad blocker), the Shopify customer form posts
         natively instead, so the email is never lost */
      async submit(e) {
        const input = this.form.querySelector('input[type="email"]');
        const valid = input.value.trim() !== '' && input.checkValidity();
        input.setAttribute('aria-invalid', String(!valid));
        this.form.querySelector('.rp-sw__error').hidden = valid;
        if (!valid) { e.preventDefault(); input.focus(); return; }
        try { localStorage.setItem('rp-popup-submitted', '1'); } catch {}
        if (this.hasAttribute('data-local')) { e.preventDefault(); this.done(); return; }
        const site = this.dataset.klaviyoSite, list = this.dataset.klaviyoList;
        if (!site || !list) return; /* no Klaviyo set: the store posts the form natively */
        e.preventDefault();
        const btn = this.form.querySelector('[type="submit"]');
        btn.setAttribute('aria-busy', 'true');
        try {
          const email = input.value.trim();
          const r = await fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(site), {
            method: 'POST',
            headers: { 'Content-Type': 'application/vnd.api+json', Accept: 'application/vnd.api+json', revision: '2024-10-15' },
            body: JSON.stringify({ data: { type: 'subscription', attributes: {
              custom_source: 'RPLNSH website pop-up',
              /* the client endpoint records email consent from the email itself; a 'subscriptions' block is refused (400) */
              profile: { data: { type: 'profile', attributes: { email } } },
            }, relationships: { list: { data: { type: 'list', id: list } } } } }),
          });
          if (!r.ok) throw new Error('Klaviyo answered ' + r.status);
        } catch (err) {
          console.error('[rp-scratch-popup] Klaviyo signup failed, saving with Shopify instead:', String((err && err.message) || err).slice(0, 200));
          btn.removeAttribute('aria-busy');
          this.form.submit();
          return;
        }
        btn.removeAttribute('aria-busy');
        /* the code rides along to checkout: /discount/CODE stores it on the session */
        const code = this.dataset.code;
        if (code && this.hasAttribute('data-apply-code')) {
          const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
          fetch(root + 'discount/' + encodeURIComponent(code), { credentials: 'same-origin' }).catch(() => {});
        }
        this.done();
      }

      done() {
        this.stage('done');
        this.querySelector('[data-sw-done]').focus({ preventScroll: true });
        const code = this.dataset.code;
        if (code) this.live.textContent = this.querySelector('[data-sw-in="done"].rp-sw__sub')?.textContent + ' ' + code;
      }

      async copy() {
        const code = this.dataset.code, label = this.querySelector('[data-sw-copy-label]');
        if (!code) return;
        try { await navigator.clipboard.writeText(code); }
        catch {
          const r = document.createRange(); r.selectNodeContents(this.querySelector('.rp-sw__code-value'));
          const sel = getSelection(); sel.removeAllRanges(); sel.addRange(r); document.execCommand && document.execCommand('copy');
        }
        if (label) { const was = label.textContent; label.textContent = this.dataset.copied || 'Copied'; setTimeout(() => { label.textContent = was; }, 1800); }
        this.live.textContent = (this.dataset.copied || 'Copied') + ': ' + code;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rp-sodium-gap"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

    const arm = () => {
      if (reduce.matches || !('IntersectionObserver' in window)) return;
      const charts = document.querySelectorAll('.rp-sg__chart:not(.is-armed)');
      if (!charts.length) return;
      const io = new IntersectionObserver((entries) => {
        for (const e of entries) {
          if (!e.isIntersecting) continue;
          io.unobserve(e.target);
          const chart = e.target;
          // Wait for the section reveal so the fill plays where it can be seen.
          const fill = () => {
            const section = chart.closest('.rp-reveal');
            if (section && !section.classList.contains('is-revealed')) return requestAnimationFrame(fill);
            chart.classList.add('is-filled');
          };
          fill();
        }
      }, { threshold: 0.35 });
      for (const c of charts) { c.classList.add('is-armed'); io.observe(c); }
    };

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', arm);
    else arm();
    document.addEventListener('shopify:section:load', arm);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rp-stockists"] && !Shopify.designMode) return;
  try {
    
  /* Groups the rendered <li> nodes by city (moving them, never retyping their
     text), filters live by name, suburb or postcode, and runs the map. */
  (() => {
    const reduce = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const fine = () => window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    const esc = (s) => String(s || '').replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));

    const groupByCity = (root) => {
      const list = root.querySelector('[data-st-list]');
      const items = [...list.querySelectorAll('[data-st-item]')];
      const groups = new Map();
      for (const item of items) {
        const city = item.dataset.city || 'Other';
        if (!groups.has(city)) groups.set(city, []);
        groups.get(city).push(item);
      }
      const cities = [...groups.keys()].sort((a, b) => a.localeCompare(b));
      const wrap = document.createElement('div');
      wrap.className = 'rp-st__groups';
      wrap.dataset.stGroups = '';
      for (const city of cities) {
        const section = document.createElement('section');
        section.className = 'rp-st__group';
        section.dataset.stGroup = city;
        const h = document.createElement('h2');
        h.className = 'rp-st__group-title rp-subheading';
        h.textContent = city;
        const ul = document.createElement('ul');
        ul.className = 'rp-st__group-list rp-unstyled-list';
        for (const item of groups.get(city)) ul.appendChild(item);
        section.append(h, ul);
        wrap.appendChild(section);
      }
      list.replaceWith(wrap);
      return { wrap, items };
    };

    /* --- providers: the same five calls on Google Maps or Leaflet ----------- */
    const loadOnce = (() => {
      const seen = new Map();
      return (key, make) => { if (!seen.has(key)) seen.set(key, make()); return seen.get(key); };
    })();
    const script = (src) => loadOnce(src, () => new Promise((resolve, reject) => {
      const s = document.createElement('script');
      s.src = src; s.async = true; s.onload = resolve; s.onerror = () => reject(new Error('script ' + src));
      document.head.appendChild(s);
    }));
    const style = (href) => loadOnce(href, () => new Promise((resolve) => {
      const l = document.createElement('link');
      l.rel = 'stylesheet'; l.href = href; l.onload = resolve; l.onerror = resolve;
      document.head.appendChild(l);
    }));

    const pinEl = (count) => {
      const el = document.createElement('span');
      el.className = 'rp-st-pin';
      el.innerHTML = '<svg viewBox="0 0 32 42" aria-hidden="true"><path class="rp-st-pin__body" d="M16 1.5C8 1.5 1.5 7.8 1.5 15.6c0 10.3 12.3 22.7 13.4 23.8a1.6 1.6 0 0 0 2.2 0c1.1-1.1 13.4-13.5 13.4-23.8C30.5 7.8 24 1.5 16 1.5z"/>'
        + (count > 1 ? '</svg><span class="rp-st-pin__count">' + count + '</span>' : '<circle class="rp-st-pin__core" cx="16" cy="15.5" r="5"/></svg>');
      return el;
    };

    const clusterEl = (n) => {
      const el = document.createElement('span');
      el.className = 'rp-st-cluster';
      el.textContent = String(n);
      return el;
    };

    const leaflet = async (el) => {
      await Promise.all([style(el.dataset.leafletCss), script(el.dataset.leafletJs)]);
      const L = window.L;
      const touch = !fine();
      const map = L.map(el, { zoomControl: false, scrollWheelZoom: !touch, dragging: !touch, tap: false, attributionControl: true, worldCopyJump: false });
      /* a view straight away: Leaflet only builds marker icons once the map has one, and clustering removes markers */
      map.setView([-28, 145], 4, { animate: false });
      L.control.zoom({ position: 'bottomright' }).addTo(map);
      map.attributionControl.setPrefix('<a href="https://leafletjs.com" target="_blank" rel="noopener">Leaflet</a>');
      L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png', { maxZoom: 19, attribution: '&copy; <a href="https://www.openstreetmap.org/copyright" target="_blank" rel="noopener">OpenStreetMap</a> contributors' }).addTo(map);
      const popup = L.popup({ closeButton: true, autoPanPadding: [24, 24], offset: [0, -36] });
      return {
        kind: 'leaflet',
        marker(pin, onClick) {
          const m = L.marker([pin.lat, pin.lng], { icon: L.divIcon({ html: pin.el, className: '', iconSize: [32, 42], iconAnchor: [16, 42] }), title: pin.title, keyboard: true, riseOnHover: true });
          m.on('click', () => onClick(pin));
          m.addTo(map);
          return { show(on) { if (on) m.addTo(map); else m.remove(); } };
        },
        fit(points) {
          if (!points.length) return;
          if (points.length === 1) map.setView([points[0].lat, points[0].lng], 15, { animate: !reduce() });
          else map.fitBounds(L.latLngBounds(points.map((p) => [p.lat, p.lng])), { padding: [48, 48], maxZoom: 15, animate: !reduce() });
        },
        focus(pin) { reduce() ? map.setView([pin.lat, pin.lng], 15) : map.flyTo([pin.lat, pin.lng], 15, { duration: 0.8 }); },
        open(pin, html) { popup.setLatLng([pin.lat, pin.lng]).setContent(html).openOn(map); },
        close() { map.closePopup(); },
        onEmptyClick(fn) { map.on('click', fn); },
        onView(fn) { map.on('zoomend moveend', fn); },
        point(p) { const pt = map.latLngToContainerPoint([p.lat, p.lng]); return { x: pt.x, y: pt.y }; },
        cluster(c, onClick) {
          const m = L.marker([c.lat, c.lng], { icon: L.divIcon({ html: c.el, className: '', iconSize: [40, 40], iconAnchor: [20, 20] }), title: c.title, keyboard: true, zIndexOffset: 500 });
          m.on('click', () => onClick(c));
          m.addTo(map);
          return { remove() { m.remove(); } };
        },
        zoomTo(points) { map.fitBounds(L.latLngBounds(points.map((p) => [p.lat, p.lng])), { padding: [64, 64], maxZoom: 16, animate: !reduce() }); },
      };
    };

    const google = async (el) => {
      const key = el.dataset.googleKey;
      await new Promise((resolve, reject) => {
        /* Google calls gm_authFailure for a refused key (wrong domain, billing off): fall back */
        const prev = window.gm_authFailure;
        window.gm_authFailure = () => { if (prev) prev(); el.dispatchEvent(new CustomEvent('rp:google-refused', { bubbles: true })); };
        window.__rpStMapsReady = resolve;
        script('https://maps.googleapis.com/maps/api/js?key=' + encodeURIComponent(key) + '&v=weekly&loading=async&libraries=marker&callback=__rpStMapsReady').catch(reject);
      });
      const g = window.google.maps;
      const { AdvancedMarkerElement } = await g.importLibrary('marker');
      const map = new g.Map(el, {
        center: { lat: -28, lng: 145 }, zoom: 4, mapId: el.dataset.googleMapId || 'DEMO_MAP_ID',
        disableDefaultUI: true, zoomControl: true, clickableIcons: false,
        gestureHandling: fine() ? 'greedy' : 'cooperative',
      });
      const info = new g.InfoWindow({ pixelOffset: new g.Size(0, -4) });
      return {
        kind: 'google',
        marker(pin, onClick) {
          const m = new AdvancedMarkerElement({ map, position: { lat: pin.lat, lng: pin.lng }, content: pin.el, title: pin.title, gmpClickable: true });
          m.addListener('click', () => onClick(pin));
          return { show(on) { m.map = on ? map : null; } };
        },
        fit(points) {
          if (!points.length) return;
          if (points.length === 1) { map.setCenter(points[0]); map.setZoom(14); return; }
          const b = new g.LatLngBounds();
          points.forEach((p) => b.extend(p));
          map.fitBounds(b, 48);
        },
        focus(pin) { map.panTo(pin); if (map.getZoom() < 15) map.setZoom(15); },
        open(pin, html) { info.setContent(html); info.setPosition(pin); info.open({ map }); },
        close() { info.close(); },
        onEmptyClick(fn) { map.addListener('click', fn); },
        onView(fn) { map.addListener('idle', fn); },
        point(p) {
          const proj = map.getProjection();
          if (!proj) return null;
          const scale = 2 ** map.getZoom();
          const w = proj.fromLatLngToPoint(new g.LatLng(p.lat, p.lng));
          return { x: w.x * scale, y: w.y * scale };
        },
        cluster(c, onClick) {
          c.el.style.transform = 'translateY(50%)';
          const m = new AdvancedMarkerElement({ map, position: { lat: c.lat, lng: c.lng }, content: c.el, title: c.title, gmpClickable: true, zIndex: 500 });
          m.addListener('click', () => onClick(c));
          return { remove() { m.map = null; } };
        },
        zoomTo(points) { const b = new g.LatLngBounds(); points.forEach((p) => b.extend(p)); map.fitBounds(b, 64); },
      };
    };

    const initMap = async (root, items) => {
      const el = root.querySelector('[data-st-map]');
      if (!el) return null;

      /* one pin per position; stockists sharing it are listed together */
      const pins = new Map();
      for (const item of items) {
        if (!item.dataset.lat) continue;
        const lat = Number(item.dataset.lat), lng = Number(item.dataset.lng);
        if (!Number.isFinite(lat) || !Number.isFinite(lng)) continue;
        const key = lat.toFixed(5) + ',' + lng.toFixed(5);
        if (!pins.has(key)) pins.set(key, { key, lat, lng, items: [] });
        pins.get(key).items.push(item);
        item.dataset.pin = key;
      }
      const list = [...pins.values()];
      list.forEach((pin) => {
        pin.title = pin.items.map((i) => i.dataset.name).join(', ');
        pin.el = pinEl(pin.items.length);
      });

      const popupHtml = (pin) => {
        const names = pin.items.map((i) => '<p class="rp-st-pop__name">' + esc(i.dataset.name) + '</p>').join('');
        const first = pin.items[0];
        return '<div class="rp-st-pop">' + names
          + '<p class="rp-st-pop__address">' + esc(first.dataset.address) + '</p>'
          + '<a class="rp-st-pop__dir" href="https://www.google.com/maps/dir/?api=1&destination=' + first.dataset.dest + '" target="_blank" rel="noopener">' + esc(el.dataset.directions) + '</a></div>';
      };

      let api = null;
      let canvas = null;
      /* each provider draws into its own canvas: a refused Google map is hidden, not torn out
         (removing its node mid-flight makes Google's own script throw) */
      const start = async (useGoogle) => {
        if (canvas) canvas.hidden = true;
        canvas = document.createElement('div');
        canvas.className = 'rp-st__canvas';
        canvas.dataset.googleKey = el.dataset.googleKey;
        canvas.dataset.googleMapId = el.dataset.googleMapId;
        canvas.dataset.leafletJs = el.dataset.leafletJs;
        canvas.dataset.leafletCss = el.dataset.leafletCss;
        el.appendChild(canvas);
        api = useGoogle ? await google(canvas) : await leaflet(canvas);
        clusters = [];
        for (const pin of list) pin.handle = api.marker(pin, (p) => select(p, 'pin'));
        api.onEmptyClick(() => select(null));
        api.onView(recluster);
        api.fit(list);
        recluster();
        el.dataset.provider = api.kind;
      };

      /* pins within 44px of each other at the current zoom merge into one circle with the count */
      let clusters = [];
      let visibleSet = null;
      const recluster = () => {
        if (!api) return;
        try { clusterNow(); } catch (err) { console.error('[rp-stockists] clustering failed:', (err && err.message) || err); list.forEach((pin) => pin.handle && pin.handle.show(true)); }
      };
      const clusterNow = () => {
        clusters.forEach((c) => c.handle.remove());
        clusters = [];
        const shown = list.filter((pin) => !visibleSet || pin.items.some((i) => visibleSet.has(i)));
        list.forEach((pin) => { if (pin.handle && !shown.includes(pin)) pin.handle.show(false); });
        const pts = shown.map((pin) => ({ pin, pt: api.point(pin) }));
        if (pts.some((p) => !p.pt)) { shown.forEach((pin) => pin.handle.show(true)); return; }
        const used = new Set();
        for (const a of pts) {
          if (used.has(a.pin)) continue;
          const group = pts.filter((b) => !used.has(b.pin) && Math.hypot(a.pt.x - b.pt.x, a.pt.y - b.pt.y) < 44);
          group.forEach((b) => used.add(b.pin));
          if (group.length === 1) { a.pin.handle.show(true); continue; }
          group.forEach((b) => b.pin.handle.show(false));
          const members = group.map((b) => b.pin);
          const count = members.reduce((n, p) => n + p.items.length, 0);
          const c = {
            lat: members.reduce((n, p) => n + p.lat, 0) / members.length,
            lng: members.reduce((n, p) => n + p.lng, 0) / members.length,
            members, title: (el.dataset.zoomLabel || '[count] stockists, zoom in').replace('[count]', count), el: clusterEl(count),
          };
          c.handle = api.cluster(c, (cc) => { api.close(); api.zoomTo(cc.members); });
          clusters.push(c);
        }
      };

      const select = (pin, from) => {
        list.forEach((p) => p.el.classList.toggle('is-active', p === pin));
        items.forEach((i) => i.classList.toggle('is-active', !!pin && pin.items.includes(i)));
        if (!pin) { api.close(); return; }
        if (from !== 'pin') api.focus(pin);
        api.open(pin, popupHtml(pin));
        if (from === 'pin') {
          const item = pin.items[0];
          if (fine() && window.innerWidth >= 1000) item.scrollIntoView({ block: 'nearest', behavior: reduce() ? 'auto' : 'smooth' });
        }
      };

      /* list items with a pin become buttons */
      for (const item of items) {
        if (!item.dataset.pin) continue;
        item.setAttribute('role', 'button');
        item.tabIndex = 0;
        item.setAttribute('aria-label', 'Show ' + item.dataset.name + ' on the map');
        const go = () => {
          const pin = pins.get(item.dataset.pin);
          select(pin, 'list');
          /* small screens: bring the map back into view */
          if (window.innerWidth < 1000) el.scrollIntoView({ block: 'center', behavior: reduce() ? 'auto' : 'smooth' });
        };
        item.addEventListener('click', (e) => { if (!e.target.closest('a')) go(); });
        item.addEventListener('keydown', (e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); go(); } });
      }

      /* touch: one finger scrolls the page, so a one-finger drag on the map shows the hint */
      const hint = root.querySelector('[data-st-hint]');
      if (hint && !fine()) {
        let timer = 0;
        el.addEventListener('touchmove', (e) => {
          if (e.touches.length !== 1 || el.dataset.provider !== 'leaflet') return;
          hint.classList.add('is-on');
          clearTimeout(timer);
          timer = setTimeout(() => hint.classList.remove('is-on'), 1400);
        }, { passive: true });
        el.addEventListener('touchstart', (e) => { if (e.touches.length > 1) hint.classList.remove('is-on'); }, { passive: true });
      }

      const wantsGoogle = !!el.dataset.googleKey;
      try {
        if (wantsGoogle) {
          el.addEventListener('rp:google-refused', () => { start(false); }, { once: true });
        }
        await start(wantsGoogle);
      } catch (err) {
        console.error('[rp-stockists] map failed:', (err && err.message) || err);
        if (wantsGoogle) { try { await start(false); } catch (e2) { console.error('[rp-stockists] fallback map failed:', (e2 && e2.message) || e2); } }
      }

      return {
        filter(visible, all) {
          if (!api) return;
          visibleSet = all ? null : visible;
          const shown = list.filter((pin) => pin.items.some((i) => visible.has(i)));
          recluster();
          api.close();
          list.forEach((p) => p.el.classList.remove('is-active'));
          items.forEach((i) => i.classList.remove('is-active'));
          if (shown.length) api.fit(shown);
        },
      };
    };

    const init = async (root) => {
      const { items } = groupByCity(root);
      const search = root.querySelector('[data-st-search]');
      const count = root.querySelector('[data-st-count]');
      const empty = root.querySelector('[data-st-empty]');
      const groupEls = [...root.querySelectorAll('[data-st-group]')];
      let map = null;

      const apply = (redraw) => {
        const q = search.value.trim().toLowerCase();
        let visible = 0;
        const shown = new Set();
        for (const item of items) {
          const match = !q || item.dataset.name.toLowerCase().includes(q) || item.dataset.city.toLowerCase().includes(q) || item.dataset.postcode.toLowerCase().includes(q);
          item.hidden = !match;
          if (match) { visible += 1; shown.add(item); }
        }
        for (const group of groupEls) {
          const hasVisible = [...group.querySelectorAll('[data-st-item]')].some((i) => !i.hidden);
          group.hidden = !hasVisible;
        }
        count.textContent = `${visible} ${visible === 1 ? (count.dataset.one || 'stockist') : (count.dataset.many || 'stockists')}`;
        empty.hidden = visible !== 0;
        if (visible === 0) empty.textContent = q ? (empty.dataset.noMatch || 'No stockists match "[search]".').replace('[search]', q) : (empty.dataset.none || 'No stockists.');
        if (map && redraw) map.filter(shown, !q);
      };

      let t = 0;
      search.addEventListener('input', () => { apply(false); clearTimeout(t); t = setTimeout(() => apply(true), 250); });
      apply(false);
      map = await initMap(root, items);
    };

    const start = () => { for (const root of document.querySelectorAll('.section-rp-stockists')) { if (root.dataset.rpSt) continue; root.dataset.rpSt = '1'; init(root); } };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
    else start();
    document.addEventListener('shopify:section:load', start);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rp-time-of-day"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const init = (root) => {
      for (const section of root.querySelectorAll('.rp-td')) {
        if (section.dataset.ready) continue;
        section.dataset.ready = '1';
        const track = section.querySelector('.rp-td__track');
        const reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
        const step = () => (track.querySelector('.rp-td__card')?.getBoundingClientRect().width || track.clientWidth) + 16;
        const go = (dir) => {
          const behavior = reduce.matches ? 'auto' : 'smooth';
          const max = track.scrollWidth - track.clientWidth;
          if (dir > 0 && track.scrollLeft >= max - 2) track.scrollTo({ left: 0, behavior });
          else if (dir < 0 && track.scrollLeft <= 2) track.scrollTo({ left: max, behavior });
          else track.scrollBy({ left: dir * step(), behavior });
        };
        section.querySelector('[data-td-prev]')?.addEventListener('click', () => go(-1));
        section.querySelector('[data-td-next]')?.addEventListener('click', () => go(1));
      }
    };
    const boot = () => init(document);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
    else boot();
    document.addEventListener('shopify:section:load', (e) => init(e.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rp-video-reviews"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const play = (video) => {
      const p = video.play();
      if (p && p.catch) p.catch(() => { });
      return p;
    };
    const still = window.matchMedia('(prefers-reduced-motion: reduce)');
    const mouse = window.matchMedia('(hover: hover) and (pointer: fine)');
    const previews = new Set();
    const root = () => (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    const clock = (s) => { s = Math.max(0, Math.floor(s || 0)); return Math.floor(s / 60) + ':' + String(s % 60).padStart(2, '0'); };
    /* hover sound: on by default; a browser that refuses sound before the visitor has clicked or tapped the page
       gets a muted preview instead, and the speaker button (a click, so always allowed) turns it on */
    let soundOn = true;
    try { if (sessionStorage.getItem('rp-vr-sound') === 'off') soundOn = false; } catch (e) { }
    const soundButtons = new Set();
    const paint = () => {
      for (const b of soundButtons) {
        const v = b.closest('.rp-vr__card')?.querySelector('video');
        const on = v && !v.paused ? !v.muted : soundOn;
        b.classList.toggle('is-on', on);
        b.setAttribute('aria-label', on ? b.dataset.labelOff : b.dataset.labelOn);
      }
    };
    const preview = (video) => {
      video.muted = !soundOn;
      const p = video.play();
      if (p && p.catch) p.catch(() => { if (!video.muted) { video.muted = true; play(video); } paint(); });
      paint();
    };
    /* one preview at a time: whichever starts pauses the rest */
    const solo = (current) => {
      for (const v of previews) if (v !== current && !v.paused) v.pause();
    };
    /* pausing only: nothing starts on scroll, a band scrolled away stops */
    const io = 'IntersectionObserver' in window
      ? new IntersectionObserver((entries) => {
        for (const entry of entries) {
          if (!entry.isIntersecting && !entry.target.paused) entry.target.pause();
        }
      })
      : null;

    /* the player: one <dialog> per section */
    const player = (section) => {
      const dialog = section.querySelector('[data-vp]');
      if (!dialog || dialog.dataset.ready) return null;
      dialog.dataset.ready = '1';
      const cards = Array.from(section.querySelectorAll('.rp-vr__card[data-vp-src]'));
      const $ = (s) => dialog.querySelector(s);
      const video = $('[data-vp-video]');
      const media = $('[data-vp-media]');
      const info = $('[data-vp-info]');
      const product = $('[data-vp-product]');
      const scrub = $('[data-vp-scrub]');
      const time = $('[data-vp-time]');
      const counter = $('[data-vp-counter]');
      const playBtn = $('[data-vp-play]');
      const muteBtn = $('[data-vp-mute]');
      const prev = $('[data-vp-step="-1"]');
      const next = $('[data-vp-step="1"]');
      const thumbs = $('[data-vp-thumbs]');
      let index = 0;
      let opener = null;
      let seeking = false;
      let frame = 0;
      let returnFocus = true;

      cards.forEach((card, i) => {
        const b = document.createElement('button');
        b.type = 'button';
        b.className = 'rp-vp__thumb';
        b.setAttribute('aria-label', 'Video ' + (i + 1) + ' of ' + cards.length);
        const img = document.createElement('img');
        img.src = card.dataset.vpPoster;
        img.alt = '';
        img.loading = 'lazy';
        b.append(img);
        b.addEventListener('click', () => show(i, true));
        thumbs.append(b);
      });

      const progress = () => {
        const d = video.duration;
        const t = video.currentTime;
        const pct = d ? (t / d) * 100 : 0;
        if (!seeking) scrub.value = String(Math.round(pct * 10));
        scrub.style.setProperty('--p', pct + '%');
        scrub.setAttribute('aria-valuetext', clock(t) + ' of ' + clock(d));
        time.textContent = clock(t) + ' / ' + clock(d);
      };
      const tick = () => { progress(); frame = video.paused ? 0 : requestAnimationFrame(tick); };
      const sync = () => {
        const paused = video.paused;
        dialog.classList.toggle('is-paused', paused);
        dialog.classList.toggle('is-muted', video.muted);
        playBtn.setAttribute('aria-label', paused ? 'Play' : 'Pause');
        muteBtn.setAttribute('aria-label', video.muted ? 'Unmute' : 'Mute');
        if (!paused && !frame) frame = requestAnimationFrame(tick);
      };
      const toggle = () => { if (video.paused) play(video); else video.pause(); };

      const show = (i, autoplay) => {
        index = Math.max(0, Math.min(cards.length - 1, i));
        const card = cards[index];
        const tInfo = card.querySelector('template[data-vp-info]');
        const tProduct = card.querySelector('template[data-vp-product]');
        info.replaceChildren(tInfo ? tInfo.content.cloneNode(true) : '');
        product.replaceChildren(tProduct ? tProduct.content.cloneNode(true) : '');
        video.poster = card.dataset.vpPoster;
        video.src = card.dataset.vpSrc;
        counter.textContent = (index + 1) + ' / ' + cards.length;
        prev.disabled = index === 0;
        next.disabled = index === cards.length - 1;
        thumbs.querySelectorAll('.rp-vp__thumb').forEach((b, k) => b.setAttribute('aria-current', k === index ? 'true' : 'false'));
        progress();
        sync();
        if (autoplay) play(video);
      };

      const open = (i, from) => {
        if (dialog.open) return;
        opener = from || document.activeElement;
        returnFocus = true;
        for (const v of previews) if (!v.paused) v.pause();
        document.documentElement.classList.add('rp-vp-lock');
        video.muted = false;
        show(i, false);
        dialog.showModal();
        playBtn.focus({ preventScroll: true });
        play(video);
      };
      const close = () => { if (dialog.open) dialog.close(); };

      dialog.addEventListener('close', () => {
        video.pause();
        cancelAnimationFrame(frame);
        frame = 0;
        video.removeAttribute('src');
        video.load();
        document.documentElement.classList.remove('rp-vp-lock');
        if (returnFocus && opener && opener.focus) opener.focus({ preventScroll: true });
      });

      dialog.querySelectorAll('[data-vp-close]').forEach((b) => b.addEventListener('click', close));
      prev.addEventListener('click', () => show(index - 1, true));
      next.addEventListener('click', () => show(index + 1, true));
      playBtn.addEventListener('click', toggle);
      muteBtn.addEventListener('click', () => { video.muted = !video.muted; sync(); });
      ['play', 'pause', 'ended', 'volumechange', 'loadedmetadata'].forEach((ev) => video.addEventListener(ev, sync));
      video.addEventListener('timeupdate', progress);
      video.addEventListener('loadedmetadata', progress);
      video.addEventListener('ended', () => { if (index < cards.length - 1) show(index + 1, true); });

      /* scrub: drag or click the bar; arrow keys jump five seconds */
      const seek = () => { if (video.duration) video.currentTime = (Number(scrub.value) / 1000) * video.duration; progress(); };
      scrub.addEventListener('pointerdown', () => { seeking = true; });
      scrub.addEventListener('input', () => { seeking = true; seek(); });
      scrub.addEventListener('change', () => { seek(); seeking = false; });
      scrub.addEventListener('pointerup', () => { seeking = false; });
      scrub.addEventListener('keydown', (e) => {
        if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
        e.preventDefault();
        e.stopPropagation();
        if (video.duration) video.currentTime = Math.max(0, Math.min(video.duration, video.currentTime + (e.key === 'ArrowRight' ? 5 : -5)));
        progress();
      });

      /* the video: a tap or click toggles, a sideways swipe changes video */
      let downX = 0;
      let downY = 0;
      let swiped = false;
      media.addEventListener('pointerdown', (e) => { downX = e.clientX; downY = e.clientY; swiped = false; });
      media.addEventListener('pointerup', (e) => {
        if (e.target.closest('.rp-vp__controls')) return;
        const dx = e.clientX - downX;
        if (Math.abs(dx) > 60 && Math.abs(dx) > Math.abs(e.clientY - downY)) {
          swiped = true;
          show(index + (dx < 0 ? 1 : -1), true);
        }
      });
      video.addEventListener('click', () => { if (!swiped) toggle(); });

      dialog.addEventListener('keydown', (e) => {
        const t = e.target;
        if (t === scrub) return;
        const onControl = t.closest && t.closest('button, a, input');
        if (e.key === 'ArrowLeft') { e.preventDefault(); show(index - 1, true); }
        else if (e.key === 'ArrowRight') { e.preventDefault(); show(index + 1, true); }
        else if ((e.key === ' ' || e.key === 'k') && !onControl) { e.preventDefault(); toggle(); }
        else if (e.key === 'm') { video.muted = !video.muted; sync(); }
      });

      /* Add to cart (single option products): add, close the player, then let
         the cart drawer take over, the same cart:changed every add in the theme sends */
      dialog.addEventListener('click', async (e) => {
        const btn = e.target.closest ? e.target.closest('[data-vp-add]') : null;
        if (!btn || btn.dataset.state === 'busy') return;
        const items = [{ id: Number(btn.dataset.vpAdd), quantity: 1 }];
        btn.dataset.state = 'busy';
        try {
          const ok = (r) => { if (!r.ok) throw new Error('cart ' + r.status); return r.json(); };
          await fetch(root() + 'cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
            body: JSON.stringify({ items }),
          }).then(ok);
          const cart = await fetch(root() + 'cart.js', { headers: { Accept: 'application/json' } }).then(ok);
          returnFocus = false;
          close();
          const added = window.RPCart ? window.RPCart.match(cart, items) : [];
          document.dispatchEvent(new CustomEvent('cart:changed', { detail: { ...cart, source: 'video', added, opener } }));
        } catch (err) {
          btn.dataset.state = 'idle';
        }
      });

      return { open };
    };

    const init = (rootEl) => {
      const sections = rootEl.matches && rootEl.matches('.section-rp-video-reviews') ? [rootEl] : Array.from(rootEl.querySelectorAll('.section-rp-video-reviews'));
      for (const section of sections) {
        const vp = player(section);

        /* mouse drag to scroll: 1.5x the pointer travel; a drag never opens a card */
        for (const carousel of section.querySelectorAll('.rp-vr__carousel')) {
          if (carousel.dataset.ready) continue;
          carousel.dataset.ready = '1';
          let down = false;
          let startX = 0;
          let startScroll = 0;
          const end = () => { down = false; carousel.classList.remove('rp-is-dragging'); };
          carousel.addEventListener('mousedown', (e) => {
            down = true;
            carousel.dataset.dragged = '';
            startX = e.pageX - carousel.offsetLeft;
            startScroll = carousel.scrollLeft;
          });
          carousel.addEventListener('mouseleave', end);
          carousel.addEventListener('mouseup', end);
          carousel.addEventListener('mousemove', (e) => {
            if (!down) return;
            const x = e.pageX - carousel.offsetLeft;
            if (Math.abs(x - startX) < 5) return;
            e.preventDefault();
            carousel.dataset.dragged = '1';
            carousel.classList.add('rp-is-dragging');
            carousel.scrollLeft = startScroll - (x - startX) * 1.5;
          });
        }

        /* each card: hover previews muted (mouse, no reduced motion); a click,
           tap or Enter on the card or its button opens the player there */
        const cards = Array.from(section.querySelectorAll('.rp-vr__card[data-vp-src]'));
        cards.forEach((card, i) => {
          if (card.dataset.ready) return;
          card.dataset.ready = '1';
          const btn = card.querySelector('[data-rp-video-play]');
          const video = card.querySelector('video');
          if (video) {
            video.muted = true;
            previews.add(video);
            card.addEventListener('pointerenter', (e) => {
              if (e.pointerType !== 'mouse' || !mouse.matches || still.matches) return;
              if (video.paused) preview(video);
            });
            card.addEventListener('pointerleave', (e) => {
              if (e.pointerType !== 'mouse' || !mouse.matches) return;
              if (!video.paused) video.pause();
            });
            video.addEventListener('play', () => { card.classList.add('is-playing'); solo(video); paint(); });
            video.addEventListener('pause', () => { card.classList.remove('is-playing'); paint(); });
            video.addEventListener('volumechange', paint);
            const sound = card.querySelector('[data-rp-card-sound]');
            /* touch: the play button plays here with sound (the tap allows it) and pauses; the card itself opens the player */
            if (btn && !mouse.matches) {
              card.closest('.rp-vr__carousel')?.classList.add('rp-vr--touch');
              btn.removeAttribute('aria-haspopup');
              btn.removeAttribute('aria-controls');
              const label = () => btn.setAttribute('aria-label', video.paused ? btn.dataset.labelPlay : btn.dataset.labelPause);
              btn.addEventListener('click', (e) => {
                e.preventDefault();
                e.stopPropagation();
                if (video.paused) preview(video); else video.pause();
              });
              video.addEventListener('play', label);
              video.addEventListener('pause', label);
              label();
            }
            if (sound) {
              sound.hidden = false;
              soundButtons.add(sound);
              sound.addEventListener('click', (e) => {
                e.preventDefault();
                e.stopPropagation();
                soundOn = video.paused ? !soundOn : video.muted;
                try { sessionStorage.setItem('rp-vr-sound', soundOn ? 'on' : 'off'); } catch (err) { }
                video.muted = !soundOn;
                if (video.paused && !still.matches) play(video);
                paint();
              });
              paint();
            }
            if (io) io.observe(video);
          }
          if (!vp) return;
          card.addEventListener('click', (e) => {
            const carousel = card.closest('.rp-vr__carousel');
            if (carousel && carousel.dataset.dragged === '1') { carousel.dataset.dragged = ''; return; }
            e.preventDefault();
            vp.open(i, btn || card);
          });
        });
      }
    };
    const boot = () => init(document);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
    else boot();
    document.addEventListener('shopify:section:load', (e) => init(e.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rp-why-sodium"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const init = (root) => {
      for (const section of root.querySelectorAll('.rp-ws')) {
        if (section.dataset.ready) continue;
        section.dataset.ready = '1';
        const steps = [...section.querySelectorAll('[data-ws-step]')];
        if (!steps.length || !('IntersectionObserver' in window)) continue;
        section.classList.add('is-telling');
        steps[0].classList.add('is-active');
        const io = new IntersectionObserver((entries) => {
          for (const e of entries) if (e.isIntersecting) for (const s of steps) s.classList.toggle('is-active', s === e.target);
        }, { rootMargin: '-45% 0px -45% 0px' });
        for (const s of steps) io.observe(s);
      }
    };
    const boot = () => init(document);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
    else boot();
    document.addEventListener('shopify:section:load', (e) => init(e.target));
  })();

  } catch(e) { console.error(e); }
})();
})();
